{
  "v": "5.7.12",
  "fr": 30,
  "ip": 0,
  "op": 90,
  "w": 800,
  "h": 600,
  "nm": "07-racoon",
  "ddd": 0,
  "assets": [],
  "layers": [
    {
      "ddd": 0,
      "ind": 1,
      "ty": 4,
      "nm": "Group 1",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            {
              "i": { "x": [0.667], "y": [1] },
              "o": { "x": [0.333], "y": [0] },
              "t": 83,
              "s": [100]
            },
            { "t": 87, "s": [0] }
          ],
          "ix": 11
        },
        "r": {
          "a": 1,
          "k": [
            {
              "i": { "x": [0.667], "y": [1] },
              "o": { "x": [0.333], "y": [0] },
              "t": 51,
              "s": [-45]
            },
            {
              "i": { "x": [0.667], "y": [1] },
              "o": { "x": [0.333], "y": [0] },
              "t": 59.096,
              "s": [14]
            },
            { "t": 63.142578125, "s": [0] }
          ],
          "ix": 10
        },
        "p": { "a": 0, "k": [352.294, 117.068, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [34.071, 75.358, 0], "ix": 1, "l": 2 },
        "s": {
          "a": 1,
          "k": [
            {
              "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
              "t": 51,
              "s": [0, 0, 100]
            },
            {
              "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
              "t": 59.096,
              "s": [110, 110, 100]
            },
            { "t": 63.142578125, "s": [100, 100, 100] }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0.508, 1.639],
                    [-0.77, 1.431],
                    [-1.884, 0.583],
                    [-1.452, -0.774],
                    [-0.525, -1.697],
                    [0.734, -1.436],
                    [1.974, -0.611],
                    [1.402, 0.773]
                  ],
                  "o": [
                    [-0.544, -1.758],
                    [0.77, -1.429],
                    [1.913, -0.592],
                    [1.452, 0.774],
                    [0.508, 1.639],
                    [-0.736, 1.436],
                    [-1.974, 0.612],
                    [-1.404, -0.774]
                  ],
                  "v": [
                    [6.525, 30.303],
                    [6.863, 25.521],
                    [10.844, 22.502],
                    [15.893, 22.775],
                    [18.86, 26.483],
                    [18.52, 31.095],
                    [14.456, 34.164],
                    [9.391, 33.922]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [-0.255, 2.67],
                    [-2.039, 3.732],
                    [-0.407, 1.438],
                    [0.657, 2.121],
                    [1.849, 1.049],
                    [2.691, -0.833],
                    [1.123, -1.93],
                    [-0.766, -2.473],
                    [0, 0],
                    [-2.589, 4.18],
                    [-5.831, 1.806],
                    [-4.309, -2.011],
                    [-1.697, -5.479],
                    [3.081, -6.139],
                    [0, 0],
                    [-1.276, -4.33]
                  ],
                  "o": [
                    [-1.233, -3.982],
                    [0.254, -2.67],
                    [2.04, -3.731],
                    [0.632, -2.192],
                    [-0.869, -2.806],
                    [-1.848, -1.046],
                    [-2.572, 0.797],
                    [-1.122, 1.933],
                    [0, 0],
                    [-1.581, -5.317],
                    [2.589, -4.181],
                    [6.011, -1.861],
                    [4.31, 2.012],
                    [1.51, 4.877],
                    [0, 0],
                    [-1.279, 2.856],
                    [0, 0]
                  ],
                  "v": [
                    [2.974, 16.14],
                    [1.507, 6.163],
                    [4.948, -3.441],
                    [8.618, -11.194],
                    [8.581, -17.664],
                    [4.505, -23.445],
                    [-2.304, -23.764],
                    [-7.846, -19.674],
                    [-8.381, -13.066],
                    [-19.281, -9.69],
                    [-17.769, -23.936],
                    [-5.138, -32.915],
                    [10.342, -32.692],
                    [19.352, -21.456],
                    [16.997, -4.932],
                    [13.162, 2.208],
                    [13.157, 12.987]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 1,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.536999990426, 0.607999973671, 0.647000002394, 1],
                "ix": 4
              },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [21.112, 46.702], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 4,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 51,
      "op": 150,
      "st": 51,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 2,
      "ty": 4,
      "nm": "Group 2",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            {
              "i": { "x": [0.667], "y": [1] },
              "o": { "x": [0.333], "y": [0] },
              "t": 86,
              "s": [100]
            },
            { "t": 90, "s": [0] }
          ],
          "ix": 11
        },
        "r": {
          "a": 1,
          "k": [
            {
              "i": { "x": [0.667], "y": [1] },
              "o": { "x": [0.333], "y": [0] },
              "t": 55.857,
              "s": [-45]
            },
            {
              "i": { "x": [0.667], "y": [1] },
              "o": { "x": [0.333], "y": [0] },
              "t": 63.952,
              "s": [14]
            },
            { "t": 68, "s": [0] }
          ],
          "ix": 10
        },
        "p": { "a": 0, "k": [432.058, 107.642, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [113.834, 65.932, 0], "ix": 1, "l": 2 },
        "s": {
          "a": 1,
          "k": [
            {
              "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
              "t": 55.857,
              "s": [0, 0, 100]
            },
            {
              "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
              "t": 63.952,
              "s": [110, 110, 100]
            },
            { "t": 68, "s": [100, 100, 100] }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-0.32, 1.557],
                    [-1.263, 0.818],
                    [-1.79, -0.368],
                    [-0.833, -1.276],
                    [0.331, -1.612],
                    [1.238, -0.837],
                    [1.875, 0.385],
                    [0.793, 1.254]
                  ],
                  "o": [
                    [0.343, -1.67],
                    [1.263, -0.816],
                    [1.818, 0.373],
                    [0.833, 1.277],
                    [-0.32, 1.556],
                    [-1.238, 0.837],
                    [-1.876, -0.386],
                    [-0.794, -1.255]
                  ],
                  "v": [
                    [-15.749, 25.301],
                    [-13.34, 21.57],
                    [-8.76, 20.897],
                    [-4.784, 23.372],
                    [-4.03, 27.708],
                    [-6.366, 31.299],
                    [-11.035, 31.977],
                    [-15.038, 29.518]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [-1.398, 2.054],
                    [-3.322, 2.119],
                    [-0.973, 0.986],
                    [-0.414, 2.015],
                    [1.033, 1.676],
                    [2.556, 0.525],
                    [1.773, -1.065],
                    [0.483, -2.35],
                    [0, 0],
                    [-3.969, 2.237],
                    [-5.54, -1.138],
                    [-2.601, -3.557],
                    [1.069, -5.206],
                    [5.241, -3.608],
                    [0, 0],
                    [0.898, -4.084]
                  ],
                  "o": [
                    [0.777, -3.783],
                    [1.399, -2.053],
                    [3.322, -2.119],
                    [1.491, -1.496],
                    [0.548, -2.665],
                    [-1.033, -1.675],
                    [-2.444, -0.501],
                    [-1.774, 1.068],
                    [0, 0],
                    [1.09, -5.022],
                    [3.968, -2.238],
                    [5.71, 1.172],
                    [2.6, 3.556],
                    [-0.952, 4.634],
                    [0, 0],
                    [-2.313, 1.748],
                    [0, 0]
                  ],
                  "v": [
                    [-12.309, 12.219],
                    [-9.046, 3.464],
                    [-1.964, -2.795],
                    [4.478, -7.451],
                    [7.336, -12.719],
                    [6.608, -19.231],
                    [1.224, -22.531],
                    [-5.102, -21.685],
                    [-8.487, -16.559],
                    [-18.841, -18.686],
                    [-11.254, -29.575],
                    [3.009, -31.224],
                    [15.475, -24.131],
                    [17.772, -10.988],
                    [8.483, 1.374],
                    [2.182, 5.457],
                    [-2.634, 14.205]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 1,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.536999990426, 0.607999973671, 0.647000002394, 1],
                "ix": 4
              },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [124.385, 39.752], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 2",
          "np": 4,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 56,
      "op": 150,
      "st": 57,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 3,
      "ty": 4,
      "nm": "Group 3",
      "sr": 1,
      "ks": {
        "o": {
          "a": 1,
          "k": [
            {
              "i": { "x": [0.667], "y": [1] },
              "o": { "x": [0.333], "y": [0] },
              "t": 85,
              "s": [100]
            },
            { "t": 89, "s": [0] }
          ],
          "ix": 11
        },
        "r": {
          "a": 1,
          "k": [
            {
              "i": { "x": [0.667], "y": [1] },
              "o": { "x": [0.333], "y": [0] },
              "t": 53.429,
              "s": [-45]
            },
            {
              "i": { "x": [0.667], "y": [1] },
              "o": { "x": [0.333], "y": [0] },
              "t": 61.523,
              "s": [14]
            },
            { "t": 65.5712890625, "s": [0] }
          ],
          "ix": 10
        },
        "p": { "a": 0, "k": [392.077, 111.328, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [73.853, 69.618, 0], "ix": 1, "l": 2 },
        "s": {
          "a": 1,
          "k": [
            {
              "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
              "t": 53.429,
              "s": [0, 0, 100]
            },
            {
              "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
              "t": 61.523,
              "s": [110, 110, 100]
            },
            { "t": 65.5712890625, "s": [100, 100, 100] }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 1.847],
                    [-1.248, 1.227],
                    [-2.123, 0],
                    [-1.246, -1.259],
                    [0, -1.912],
                    [1.213, -1.243],
                    [2.225, 0],
                    [1.196, 1.242]
                  ],
                  "o": [
                    [0, -1.982],
                    [1.246, -1.224],
                    [2.157, 0],
                    [1.247, 1.258],
                    [0, 1.847],
                    [-1.214, 1.242],
                    [-2.225, 0],
                    [-1.197, -1.243]
                  ],
                  "v": [
                    [-7.937, 31.119],
                    [-6.067, 26.309],
                    [-1.011, 24.472],
                    [4.096, 26.361],
                    [5.967, 31.119],
                    [4.148, 35.755],
                    [-1.011, 37.618],
                    [-6.143, 35.755]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [-1.112, 2.665],
                    [-3.286, 3.188],
                    [-0.877, 1.349],
                    [0, 2.391],
                    [1.568, 1.667],
                    [3.034, 0],
                    [1.769, -1.628],
                    [0, -2.788],
                    [0, 0],
                    [-3.994, 3.475],
                    [-6.572, 0],
                    [-3.792, -3.441],
                    [0, -6.176],
                    [5.124, -5.332],
                    [0, 0],
                    [0.067, -4.86]
                  ],
                  "o": [
                    [0, -4.489],
                    [1.112, -2.665],
                    [3.287, -3.189],
                    [1.348, -2.053],
                    [0, -3.163],
                    [-1.567, -1.666],
                    [-2.899, 0],
                    [-1.77, 1.63],
                    [0, 0],
                    [0.068, -5.973],
                    [3.995, -3.476],
                    [6.776, 0],
                    [3.792, 3.442],
                    [0, 5.498],
                    [0, 0],
                    [-2.224, 2.53],
                    [0, 0]
                  ],
                  "v": [
                    [-7.079, 15.421],
                    [-5.41, 4.692],
                    [1.188, -4.089],
                    [7.433, -10.895],
                    [9.455, -17.561],
                    [7.105, -24.805],
                    [0.202, -27.303],
                    [-6.8, -24.861],
                    [-9.455, -18.234],
                    [-21.742, -18.234],
                    [-15.649, -32.405],
                    [0.202, -37.618],
                    [16.054, -32.457],
                    [21.742, -18.032],
                    [14.057, -1.786],
                    [7.838, 4.337],
                    [4.399, 15.421]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 1,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.536999990426, 0.607999973671, 0.647000002394, 1],
                "ix": 4
              },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [74.853, 37.868], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 3",
          "np": 4,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 53,
      "op": 150,
      "st": 54,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 4,
      "ty": 4,
      "nm": "Group 23",
      "parent": 8,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [178.356, 105.656, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [178.356, 105.656, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, -36.28], [36.28, 0], [0, 36.28], [-36.28, 0]],
                  "o": [[0, 36.28], [-36.28, 0], [0, -36.28], [36.28, 0]],
                  "v": [[65.69, 0], [0, 65.69], [-65.69, 0], [0, -65.69]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.313999998803, 0.337000020345, 0.352999997606, 1],
                "ix": 3
              },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 12.452, "ix": 5 },
              "lc": 2,
              "lj": 1,
              "ml": 10,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [259.61, 96.82], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 9",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, -36.28], [36.28, 0], [0, 36.28], [-36.28, 0]],
                  "o": [[0, 36.28], [-36.28, 0], [0, -36.28], [36.28, 0]],
                  "v": [[65.69, 0], [0, 65.69], [-65.69, 0], [0, -65.69]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.313999998803, 0.337000020345, 0.352999997606, 1],
                "ix": 3
              },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 12.452, "ix": 5 },
              "lc": 2,
              "lj": 1,
              "ml": 10,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [96.82, 96.82], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 14",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 2,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, -6.759], [6.759, 0], [0, 6.759], [-6.759, 0]],
                  "o": [[0, 6.759], [-6.759, 0], [0, -6.759], [6.759, 0]],
                  "v": [[12.239, 0], [0, 12.239], [-12.239, 0], [0, -12.239]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.536999990426, 0.607999973671, 0.647000002394, 1],
                "ix": 4
              },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [179.803, 51.559], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 20",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 3,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, -6.759], [6.759, 0], [0, 6.759], [-6.759, 0]],
                  "o": [[0, 6.759], [-6.759, 0], [0, -6.759], [6.759, 0]],
                  "v": [[12.239, 0], [0, 12.239], [-12.239, 0], [0, -12.239]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.536999990426, 0.607999973671, 0.647000002394, 1],
                "ix": 4
              },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [179.803, 51.559], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 15",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 4,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [0, 0]],
                  "o": [[0, 0], [0, 0]],
                  "v": [[-8.234, -4.277], [-22.04, -11.807]],
                  "c": false
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.275, 0.289999988032, 0.298000021542, 1],
                "ix": 3
              },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 36.414, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [201.712, 60.838], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 16",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 5,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[-7.245, 3.881], [0, 0]],
                  "o": [[12.284, -6.58], [0, 0]],
                  "v": [[6.38, -3.248], [22.04, -11.807]],
                  "c": false
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.275, 0.289999988032, 0.298000021542, 1],
                "ix": 3
              },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 36.414, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [156.976, 60.838], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 17",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 6,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 150,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 5,
      "ty": 4,
      "nm": "Group 24",
      "parent": 8,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [178.356, 105.656, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [178.356, 105.656, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, -36.28], [36.28, 0], [0, 36.28], [-36.28, 0]],
                  "o": [[0, 36.28], [-36.28, 0], [0, -36.28], [36.28, 0]],
                  "v": [[65.69, 0], [0, 65.69], [-65.69, 0], [0, -65.69]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.313999998803, 0.337000020345, 0.352999997606, 1],
                "ix": 3
              },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 0, "ix": 5 },
              "lc": 1,
              "lj": 1,
              "ml": 10,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.536956787109, 0.607940673828, 0.646942138672, 1],
                "ix": 4
              },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [96.82, 96.82], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 75, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 17",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, -36.28], [36.28, 0], [0, 36.28], [-36.28, 0]],
                  "o": [[0, 36.28], [-36.28, 0], [0, -36.28], [36.28, 0]],
                  "v": [[65.69, 0], [0, 65.69], [-65.69, 0], [0, -65.69]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.313999998803, 0.337000020345, 0.352999997606, 1],
                "ix": 3
              },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 0, "ix": 5 },
              "lc": 1,
              "lj": 1,
              "ml": 10,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.536956787109, 0.607940673828, 0.646942138672, 1],
                "ix": 4
              },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [259.61, 96.82], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 75, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 18",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 2,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 49,
                    "s": [
                      {
                        "i": [
                          [0, -36.28],
                          [60.286, -9.054],
                          [-18.257, 35.666],
                          [-27.608, 0]
                        ],
                        "o": [
                          [0, 6.775],
                          [-47.786, 8.127],
                          [9.719, -24.129],
                          [36.28, 0]
                        ],
                        "v": [
                          [65.69, 0],
                          [0.5, 64.69],
                          [-60.957, -24.53],
                          [0, -65.69]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 54,
                    "s": [
                      {
                        "i": [
                          [0, -36.28],
                          [6.214, -9.873],
                          [24.171, 30.347],
                          [-27.608, 0]
                        ],
                        "o": [
                          [0, 6.775],
                          [-47.786, 8.127],
                          [9.719, -24.129],
                          [36.28, 0]
                        ],
                        "v": [
                          [65.69, 0],
                          [59.5, 24.69],
                          [-60.957, -24.53],
                          [0, -65.69]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 59,
                    "s": [
                      {
                        "i": [
                          [-7.904, -8.864],
                          [0.786, -6.054],
                          [24.171, 30.347],
                          [-27.608, 0]
                        ],
                        "o": [
                          [4.509, 5.057],
                          [-47.786, 8.127],
                          [10.743, -9.834],
                          [36.28, 0]
                        ],
                        "v": [
                          [55.19, -35],
                          [61, -11.81],
                          [-46.957, -47.03],
                          [0, -65.69]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 77,
                    "s": [
                      {
                        "i": [
                          [-7.904, -8.864],
                          [0.786, -6.054],
                          [24.171, 30.347],
                          [-27.608, 0]
                        ],
                        "o": [
                          [4.509, 5.057],
                          [-47.786, 8.127],
                          [10.743, -9.834],
                          [36.28, 0]
                        ],
                        "v": [
                          [55.19, -35],
                          [61, -11.81],
                          [-46.957, -47.03],
                          [0, -65.69]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 82,
                    "s": [
                      {
                        "i": [
                          [0, -36.28],
                          [6.214, -9.873],
                          [24.171, 30.347],
                          [-27.608, 0]
                        ],
                        "o": [
                          [0, 6.775],
                          [-47.786, 8.127],
                          [9.719, -24.129],
                          [36.28, 0]
                        ],
                        "v": [
                          [65.69, 0],
                          [59.5, 24.69],
                          [-60.957, -24.53],
                          [0, -65.69]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "t": 86,
                    "s": [
                      {
                        "i": [
                          [0, -36.28],
                          [60.286, -9.054],
                          [-18.257, 35.666],
                          [-27.608, 0]
                        ],
                        "o": [
                          [0, 6.775],
                          [-47.786, 8.127],
                          [9.719, -24.129],
                          [36.28, 0]
                        ],
                        "v": [
                          [65.69, 0],
                          [0.5, 64.69],
                          [-60.957, -24.53],
                          [0, -65.69]
                        ],
                        "c": true
                      }
                    ]
                  }
                ],
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.313999998803, 0.337000020345, 0.352999997606, 1],
                "ix": 3
              },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 0, "ix": 5 },
              "lc": 1,
              "lj": 1,
              "ml": 10,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": [0.833], "y": [0.833] },
                    "o": { "x": [0.167], "y": [0.167] },
                    "t": 54,
                    "s": [0.536987304688, 0.607971191406, 0.64697265625, 1]
                  },
                  {
                    "i": { "x": [0.833], "y": [0.833] },
                    "o": { "x": [0.167], "y": [0.167] },
                    "t": 59,
                    "s": [0.136993408203, 0.226989746094, 0.332977294922, 1]
                  },
                  {
                    "i": { "x": [0.833], "y": [0.833] },
                    "o": { "x": [0.167], "y": [0.167] },
                    "t": 82,
                    "s": [0.136993408203, 0.226989746094, 0.332977294922, 1]
                  },
                  {
                    "t": 86,
                    "s": [0.536987304688, 0.607971191406, 0.64697265625, 1]
                  }
                ],
                "ix": 4
              },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [259.82, 96.82], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [-100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 16",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 3,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, -36.28], [36.28, 0], [0, 36.28], [-36.28, 0]],
                  "o": [[0, 36.28], [-36.28, 0], [0, -36.28], [36.28, 0]],
                  "v": [[65.69, 0], [0, 65.69], [-65.69, 0], [0, -65.69]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.313999998803, 0.337000020345, 0.352999997606, 1],
                "ix": 3
              },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 0, "ix": 5 },
              "lc": 1,
              "lj": 1,
              "ml": 10,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [1, 0.724975585938, 0.313995361328, 1],
                "ix": 4
              },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [259.61, 96.82], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 9",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 4,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 49,
                    "s": [
                      {
                        "i": [
                          [0, -36.28],
                          [59.714, -10.054],
                          [-15.329, 36.666],
                          [-27.608, 0]
                        ],
                        "o": [
                          [0, 6.775],
                          [-47.786, 8.127],
                          [9.719, -24.129],
                          [36.28, 0]
                        ],
                        "v": [
                          [65.69, 0],
                          [1.5, 64.69],
                          [-60.957, -24.53],
                          [0, -65.69]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 54,
                    "s": [
                      {
                        "i": [
                          [0, -36.28],
                          [6.214, -9.873],
                          [24.171, 30.347],
                          [-27.608, 0]
                        ],
                        "o": [
                          [0, 6.775],
                          [-47.786, 8.127],
                          [9.719, -24.129],
                          [36.28, 0]
                        ],
                        "v": [
                          [65.69, 0],
                          [59.5, 24.69],
                          [-60.957, -24.53],
                          [0, -65.69]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 59,
                    "s": [
                      {
                        "i": [
                          [-16.976, -14.864],
                          [0.214, -10.054],
                          [15.671, 38.666],
                          [-19.786, 1.826]
                        ],
                        "o": [
                          [5.097, 4.463],
                          [-5.786, 6.446],
                          [11.671, -15.334],
                          [26.634, -2.458]
                        ],
                        "v": [
                          [53.19, -39.5],
                          [65.5, -13.31],
                          [-47.957, -46.53],
                          [0, -65.69]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 77,
                    "s": [
                      {
                        "i": [
                          [-16.976, -14.864],
                          [0.214, -10.054],
                          [15.671, 38.666],
                          [-19.786, 1.826]
                        ],
                        "o": [
                          [5.097, 4.463],
                          [-5.786, 6.446],
                          [11.671, -15.334],
                          [26.634, -2.458]
                        ],
                        "v": [
                          [53.19, -39.5],
                          [65.5, -13.31],
                          [-47.957, -46.53],
                          [0, -65.69]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 82,
                    "s": [
                      {
                        "i": [
                          [0, -36.28],
                          [6.214, -9.873],
                          [24.171, 30.347],
                          [-27.608, 0]
                        ],
                        "o": [
                          [0, 6.775],
                          [-47.786, 8.127],
                          [9.719, -24.129],
                          [36.28, 0]
                        ],
                        "v": [
                          [65.69, 0],
                          [59.5, 24.69],
                          [-60.957, -24.53],
                          [0, -65.69]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "t": 86,
                    "s": [
                      {
                        "i": [
                          [0, -36.28],
                          [59.714, -10.054],
                          [-15.329, 36.666],
                          [-27.608, 0]
                        ],
                        "o": [
                          [0, 6.775],
                          [-47.786, 8.127],
                          [9.719, -24.129],
                          [36.28, 0]
                        ],
                        "v": [
                          [65.69, 0],
                          [1.5, 64.69],
                          [-60.957, -24.53],
                          [0, -65.69]
                        ],
                        "c": true
                      }
                    ]
                  }
                ],
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.313999998803, 0.337000020345, 0.352999997606, 1],
                "ix": 3
              },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 0, "ix": 5 },
              "lc": 1,
              "lj": 1,
              "ml": 10,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": [0.833], "y": [0.833] },
                    "o": { "x": [0.167], "y": [0.167] },
                    "t": 54,
                    "s": [0.536987304688, 0.607971191406, 0.64697265625, 1]
                  },
                  {
                    "i": { "x": [0.833], "y": [0.833] },
                    "o": { "x": [0.167], "y": [0.167] },
                    "t": 59,
                    "s": [0.136993408203, 0.226989746094, 0.332977294922, 1]
                  },
                  {
                    "i": { "x": [0.833], "y": [0.833] },
                    "o": { "x": [0.167], "y": [0.167] },
                    "t": 82,
                    "s": [0.136993408203, 0.226989746094, 0.332977294922, 1]
                  },
                  {
                    "t": 86,
                    "s": [0.536987304688, 0.607971191406, 0.64697265625, 1]
                  }
                ],
                "ix": 4
              },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [96.82, 96.82], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 15",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 5,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, -36.28], [36.28, 0], [0, 36.28], [-36.28, 0]],
                  "o": [[0, 36.28], [-36.28, 0], [0, -36.28], [36.28, 0]],
                  "v": [[65.69, 0], [0, 65.69], [-65.69, 0], [0, -65.69]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.313999998803, 0.337000020345, 0.352999997606, 1],
                "ix": 3
              },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 0, "ix": 5 },
              "lc": 1,
              "lj": 1,
              "ml": 10,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [1, 0.724975585938, 0.313995361328, 1],
                "ix": 4
              },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [96.82, 96.82], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 14",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 6,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 49,
      "op": 86,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 6,
      "ty": 4,
      "nm": "lids",
      "parent": 8,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [177.004, 99.698, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [177.004, 99.698, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 0,
                    "s": [
                      {
                        "i": [[0, 0], [0, 0], [32.692, 0.605]],
                        "o": [[0, 0], [0, 0], [-32.692, -0.606]],
                        "v": [
                          [-46.919, -14.833],
                          [46.919, -14.833],
                          [0.908, 14.228]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 4,
                    "s": [
                      {
                        "i": [[0, 0], [0, 0], [51.396, 0.881]],
                        "o": [[0, 0], [0, 0], [-47.855, -0.82]],
                        "v": [
                          [-42.669, -37.833],
                          [51.169, -37.833],
                          [3.408, 5.728]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 6,
                    "s": [
                      {
                        "i": [[0, 0], [0, 0], [51.396, 0.881]],
                        "o": [[0, 0], [0, 0], [-47.855, -0.82]],
                        "v": [
                          [-42.669, -37.833],
                          [51.169, -37.833],
                          [3.408, 5.728]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 10,
                    "s": [
                      {
                        "i": [[0, 0], [0, 0], [32.692, 0.605]],
                        "o": [[0, 0], [0, 0], [-32.692, -0.606]],
                        "v": [
                          [-46.919, -14.833],
                          [46.919, -14.833],
                          [0.908, 14.228]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 45,
                    "s": [
                      {
                        "i": [[0, 0], [0, 0], [32.692, 0.605]],
                        "o": [[0, 0], [0, 0], [-32.692, -0.606]],
                        "v": [
                          [-46.919, -14.833],
                          [46.919, -14.833],
                          [0.908, 14.228]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.167, "y": 0 },
                    "t": 49,
                    "s": [
                      {
                        "i": [[0, 0], [0, 0], [51.396, 0.881]],
                        "o": [[0, 0], [0, 0], [-47.855, -0.82]],
                        "v": [
                          [-42.669, -37.833],
                          [51.169, -37.833],
                          [3.408, 5.728]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 86,
                    "s": [
                      {
                        "i": [[0, 0], [0, 0], [51.396, 0.881]],
                        "o": [[0, 0], [0, 0], [-47.855, -0.82]],
                        "v": [
                          [-42.669, -37.833],
                          [51.169, -37.833],
                          [3.408, 5.728]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "t": 90,
                    "s": [
                      {
                        "i": [[0, 0], [0, 0], [32.692, 0.605]],
                        "o": [[0, 0], [0, 0], [-32.692, -0.606]],
                        "v": [
                          [-46.919, -14.833],
                          [46.919, -14.833],
                          [0.908, 14.228]
                        ],
                        "c": true
                      }
                    ]
                  }
                ],
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.536999990426, 0.607999973671, 0.647000002394, 1],
                "ix": 4
              },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [255.98, 139.348], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 0,
                    "s": [
                      {
                        "i": [[0, 0], [0, 0], [32.692, 0.605]],
                        "o": [[0, 0], [0, 0], [-32.692, -0.606]],
                        "v": [
                          [-46.919, -14.833],
                          [46.919, -14.833],
                          [0.908, 14.228]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 4,
                    "s": [
                      {
                        "i": [[0, 0], [0, 0], [44.725, 0.1]],
                        "o": [[0, 0], [0, 0], [-53.275, -0.119]],
                        "v": [
                          [-47.287, -38.333],
                          [46.551, -38.333],
                          [0.782, 5.728]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 6,
                    "s": [
                      {
                        "i": [[0, 0], [0, 0], [44.725, 0.1]],
                        "o": [[0, 0], [0, 0], [-53.275, -0.119]],
                        "v": [
                          [-47.287, -38.333],
                          [46.551, -38.333],
                          [0.782, 5.728]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 10,
                    "s": [
                      {
                        "i": [[0, 0], [0, 0], [32.692, 0.605]],
                        "o": [[0, 0], [0, 0], [-32.692, -0.606]],
                        "v": [
                          [-46.919, -14.833],
                          [46.919, -14.833],
                          [0.908, 14.228]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 45,
                    "s": [
                      {
                        "i": [[0, 0], [0, 0], [32.692, 0.605]],
                        "o": [[0, 0], [0, 0], [-32.692, -0.606]],
                        "v": [
                          [-46.919, -14.833],
                          [46.919, -14.833],
                          [0.908, 14.228]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.167, "y": 0 },
                    "t": 49,
                    "s": [
                      {
                        "i": [[0, 0], [0, 0], [44.725, 0.1]],
                        "o": [[0, 0], [0, 0], [-53.275, -0.119]],
                        "v": [
                          [-47.287, -38.333],
                          [46.551, -38.333],
                          [0.782, 5.728]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 86,
                    "s": [
                      {
                        "i": [[0, 0], [0, 0], [44.725, 0.1]],
                        "o": [[0, 0], [0, 0], [-53.275, -0.119]],
                        "v": [
                          [-47.287, -38.333],
                          [46.551, -38.333],
                          [0.782, 5.728]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "t": 90,
                    "s": [
                      {
                        "i": [[0, 0], [0, 0], [32.692, 0.605]],
                        "o": [[0, 0], [0, 0], [-32.692, -0.606]],
                        "v": [
                          [-46.919, -14.833],
                          [46.919, -14.833],
                          [0.908, 14.228]
                        ],
                        "c": true
                      }
                    ]
                  }
                ],
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.536999990426, 0.607999973671, 0.647000002394, 1],
                "ix": 4
              },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [98.027, 139.348], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 2",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 2,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 0,
                    "s": [
                      {
                        "i": [[0, 0], [0, 0], [32.692, -0.605]],
                        "o": [[0, 0], [0, 0], [-32.692, 0.606]],
                        "v": [
                          [-46.919, 14.832],
                          [46.919, 14.832],
                          [0.908, -14.228]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 4,
                    "s": [
                      {
                        "i": [[0, 0], [0, 0], [56.65, 0.251]],
                        "o": [[0, 0], [0, 0], [-54.354, -0.241]],
                        "v": [
                          [-43.419, 43.209],
                          [50.419, 43.209],
                          [3.408, -14.351]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 6,
                    "s": [
                      {
                        "i": [[0, 0], [0, 0], [56.65, 0.251]],
                        "o": [[0, 0], [0, 0], [-54.354, -0.241]],
                        "v": [
                          [-43.419, 43.209],
                          [50.419, 43.209],
                          [3.408, -14.351]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 10,
                    "s": [
                      {
                        "i": [[0, 0], [0, 0], [32.692, -0.605]],
                        "o": [[0, 0], [0, 0], [-32.692, 0.606]],
                        "v": [
                          [-46.919, 14.832],
                          [46.919, 14.832],
                          [0.908, -14.228]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 45,
                    "s": [
                      {
                        "i": [[0, 0], [0, 0], [32.692, -0.605]],
                        "o": [[0, 0], [0, 0], [-32.692, 0.606]],
                        "v": [
                          [-46.919, 14.832],
                          [46.919, 14.832],
                          [0.908, -14.228]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.167, "y": 0 },
                    "t": 49,
                    "s": [
                      {
                        "i": [[0, 0], [0, 0], [56.65, 0.251]],
                        "o": [[0, 0], [0, 0], [-54.354, -0.241]],
                        "v": [
                          [-43.419, 43.209],
                          [50.419, 43.209],
                          [3.408, -14.351]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 86,
                    "s": [
                      {
                        "i": [[0, 0], [0, 0], [56.65, 0.251]],
                        "o": [[0, 0], [0, 0], [-54.354, -0.241]],
                        "v": [
                          [-43.419, 43.209],
                          [50.419, 43.209],
                          [3.408, -14.351]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "t": 90,
                    "s": [
                      {
                        "i": [[0, 0], [0, 0], [32.692, -0.605]],
                        "o": [[0, 0], [0, 0], [-32.692, 0.606]],
                        "v": [
                          [-46.919, 14.832],
                          [46.919, 14.832],
                          [0.908, -14.228]
                        ],
                        "c": true
                      }
                    ]
                  }
                ],
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.536999990426, 0.607999973671, 0.647000002394, 1],
                "ix": 4
              },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [255.98, 60.048], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 3",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 3,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 0,
                    "s": [
                      {
                        "i": [[0, 0], [0, 0], [32.692, -0.605]],
                        "o": [[0, 0], [0, 0], [-32.692, 0.606]],
                        "v": [
                          [-46.919, 14.832],
                          [46.919, 14.832],
                          [0.908, -14.228]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 4,
                    "s": [
                      {
                        "i": [[0, 0], [0, 0], [48.99, -2.562]],
                        "o": [[0, 0], [0, 0], [-59.948, 3.135]],
                        "v": [
                          [-46.872, 41.832],
                          [46.966, 41.832],
                          [-1.045, -16.728]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 6,
                    "s": [
                      {
                        "i": [[0, 0], [0, 0], [48.99, -2.562]],
                        "o": [[0, 0], [0, 0], [-59.948, 3.135]],
                        "v": [
                          [-46.872, 41.832],
                          [46.966, 41.832],
                          [-1.045, -16.728]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 10,
                    "s": [
                      {
                        "i": [[0, 0], [0, 0], [32.692, -0.605]],
                        "o": [[0, 0], [0, 0], [-32.692, 0.606]],
                        "v": [
                          [-46.919, 14.832],
                          [46.919, 14.832],
                          [0.908, -14.228]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 45,
                    "s": [
                      {
                        "i": [[0, 0], [0, 0], [32.692, -0.605]],
                        "o": [[0, 0], [0, 0], [-32.692, 0.606]],
                        "v": [
                          [-46.919, 14.832],
                          [46.919, 14.832],
                          [0.908, -14.228]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.167, "y": 0 },
                    "t": 49,
                    "s": [
                      {
                        "i": [[0, 0], [0, 0], [48.99, -2.562]],
                        "o": [[0, 0], [0, 0], [-59.948, 3.135]],
                        "v": [
                          [-46.872, 41.832],
                          [46.966, 41.832],
                          [-1.045, -16.728]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 86,
                    "s": [
                      {
                        "i": [[0, 0], [0, 0], [48.99, -2.562]],
                        "o": [[0, 0], [0, 0], [-59.948, 3.135]],
                        "v": [
                          [-46.872, 41.832],
                          [46.966, 41.832],
                          [-1.045, -16.728]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "t": 90,
                    "s": [
                      {
                        "i": [[0, 0], [0, 0], [32.692, -0.605]],
                        "o": [[0, 0], [0, 0], [-32.692, 0.606]],
                        "v": [
                          [-46.919, 14.832],
                          [46.919, 14.832],
                          [0.908, -14.228]
                        ],
                        "c": true
                      }
                    ]
                  }
                ],
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.536999990426, 0.607999973671, 0.647000002394, 1],
                "ix": 4
              },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [98.027, 60.048], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 4",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 4,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 150,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 7,
      "ty": 4,
      "nm": "pupils",
      "parent": 8,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": {
          "a": 1,
          "k": [
            {
              "i": { "x": 0.833, "y": 0.833 },
              "o": { "x": 0.167, "y": 0.167 },
              "t": 10,
              "s": [178.263, 96.822, 0],
              "to": [3, 0, 0],
              "ti": [-3, 0, 0]
            },
            {
              "i": { "x": 0.833, "y": 0.833 },
              "o": { "x": 0.167, "y": 0.167 },
              "t": 14,
              "s": [196.263, 96.822, 0],
              "to": [0, 0, 0],
              "ti": [0, 0, 0]
            },
            {
              "i": { "x": 0.833, "y": 0.833 },
              "o": { "x": 0.167, "y": 0.167 },
              "t": 24,
              "s": [196.263, 96.822, 0],
              "to": [-6, 0, 0],
              "ti": [6, 0, 0]
            },
            {
              "i": { "x": 0.833, "y": 0.833 },
              "o": { "x": 0.167, "y": 0.167 },
              "t": 29,
              "s": [160.263, 96.822, 0],
              "to": [0, 0, 0],
              "ti": [0, 0, 0]
            },
            {
              "i": { "x": 0.833, "y": 0.833 },
              "o": { "x": 0.167, "y": 0.167 },
              "t": 39,
              "s": [160.263, 96.822, 0],
              "to": [3, 0, 0],
              "ti": [-3, 0, 0]
            },
            { "t": 43, "s": [178.263, 96.822, 0] }
          ],
          "ix": 2,
          "l": 2
        },
        "a": { "a": 0, "k": [178.263, 96.822, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [1.166, 3.208],
                        [-3.208, 1.166],
                        [-1.166, -3.208],
                        [3.208, -1.166]
                      ],
                      "o": [
                        [-1.166, -3.208],
                        [3.208, -1.166],
                        [1.165, 3.208],
                        [-3.208, 1.165]
                      ],
                      "v": [
                        [-5.808, 2.111],
                        [-2.11, -5.808],
                        [5.809, -2.11],
                        [2.111, 5.809]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [1, 0.952999997606, 0.875, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [244.028, 116.642], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 5",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [2.043, 5.621],
                        [-5.622, 2.043],
                        [-2.043, -5.622],
                        [5.622, -2.043]
                      ],
                      "o": [
                        [-2.043, -5.621],
                        [5.621, -2.043],
                        [2.043, 5.621],
                        [-5.621, 2.043]
                      ],
                      "v": [
                        [-10.178, 3.698],
                        [-3.698, -10.178],
                        [10.179, -3.698],
                        [3.699, 10.178]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [1, 0.952999997606, 0.875, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [271.182, 81.653], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 6",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 2,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [4.751, 13.074],
                        [-13.075, 4.751],
                        [-4.751, -13.075],
                        [13.074, -4.751]
                      ],
                      "o": [
                        [-4.751, -13.075],
                        [13.074, -4.751],
                        [4.751, 13.074],
                        [-13.075, 4.751]
                      ],
                      "v": [
                        [-23.673, 8.602],
                        [-8.603, -23.674],
                        [23.673, -8.603],
                        [8.603, 23.673]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": {
                    "a": 0,
                    "k": [0.136999990426, 0.226999993418, 0.33300000359, 1],
                    "ix": 4
                  },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [259.658, 96.772], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 7",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 3,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [1.166, 3.208],
                        [-3.208, 1.166],
                        [-1.166, -3.208],
                        [3.208, -1.166]
                      ],
                      "o": [
                        [-1.166, -3.208],
                        [3.208, -1.166],
                        [1.165, 3.208],
                        [-3.208, 1.165]
                      ],
                      "v": [
                        [-5.808, 2.111],
                        [-2.11, -5.808],
                        [5.809, -2.11],
                        [2.111, 5.809]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [1, 0.952999997606, 0.875, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [81.238, 116.642], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 10",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 4,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [2.043, 5.621],
                        [-5.622, 2.043],
                        [-2.043, -5.622],
                        [5.622, -2.043]
                      ],
                      "o": [
                        [-2.043, -5.621],
                        [5.621, -2.043],
                        [2.043, 5.621],
                        [-5.621, 2.043]
                      ],
                      "v": [
                        [-10.178, 3.698],
                        [-3.699, -10.178],
                        [10.179, -3.698],
                        [3.699, 10.178]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [1, 0.952999997606, 0.875, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [108.392, 81.653], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 11",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 5,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [4.751, 13.074],
                        [-13.075, 4.751],
                        [-4.751, -13.075],
                        [13.074, -4.751]
                      ],
                      "o": [
                        [-4.751, -13.075],
                        [13.074, -4.751],
                        [4.751, 13.074],
                        [-13.074, 4.751]
                      ],
                      "v": [
                        [-23.673, 8.602],
                        [-8.603, -23.674],
                        [23.673, -8.603],
                        [8.603, 23.673]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": {
                    "a": 0,
                    "k": [0.136999990426, 0.226999993418, 0.33300000359, 1],
                    "ix": 4
                  },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [96.868, 96.772], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 12",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 6,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [178.263, 96.822], "ix": 2 },
              "a": { "a": 0, "k": [178.263, 96.822], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 21",
          "np": 6,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 150,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 8,
      "ty": 4,
      "nm": "Group 22",
      "parent": 16,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": {
          "a": 1,
          "k": [
            {
              "i": { "x": 0.667, "y": 1 },
              "o": { "x": 0.333, "y": 0 },
              "t": 49,
              "s": [170.724, 140.362, 0],
              "to": [0, 15, 0],
              "ti": [0, -15, 0]
            },
            {
              "i": { "x": 0.667, "y": 0.667 },
              "o": { "x": 0.333, "y": 0.333 },
              "t": 59,
              "s": [170.724, 230.362, 0],
              "to": [0, 0, 0],
              "ti": [0, 0, 0]
            },
            {
              "i": { "x": 0.667, "y": 1 },
              "o": { "x": 0.333, "y": 0 },
              "t": 77,
              "s": [170.724, 230.362, 0],
              "to": [0, -15, 0],
              "ti": [0, 15, 0]
            },
            { "t": 87, "s": [170.724, 140.362, 0] }
          ],
          "ix": 2,
          "l": 2
        },
        "a": { "a": 0, "k": [178.356, 105.656, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [8.678, 23.881],
                    [-23.881, 8.678],
                    [-8.678, -23.881],
                    [23.881, -8.678]
                  ],
                  "o": [
                    [-8.678, -23.881],
                    [23.881, -8.678],
                    [8.678, 23.881],
                    [-23.881, 8.677]
                  ],
                  "v": [
                    [-43.241, 15.713],
                    [-15.713, -43.24],
                    [43.24, -15.713],
                    [15.712, 43.241]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [1, 0.952999997606, 0.875, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [259.658, 96.772], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 8",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, -36.28], [36.28, 0], [0, 36.28], [-36.28, 0]],
                  "o": [[0, 36.28], [-36.28, 0], [0, -36.28], [36.28, 0]],
                  "v": [[65.69, 0], [0, 65.69], [-65.69, 0], [0, -65.69]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.313999998803, 0.337000020345, 0.352999997606, 1],
                "ix": 3
              },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 12.452, "ix": 5 },
              "lc": 1,
              "lj": 1,
              "ml": 10,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.536999990426, 0.607999973671, 0.647000002394, 1],
                "ix": 4
              },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [259.61, 96.82], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 9",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 2,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [8.678, 23.881],
                    [-23.881, 8.678],
                    [-8.678, -23.881],
                    [23.881, -8.678]
                  ],
                  "o": [
                    [-8.678, -23.881],
                    [23.881, -8.678],
                    [8.678, 23.881],
                    [-23.881, 8.677]
                  ],
                  "v": [
                    [-43.24, 15.713],
                    [-15.713, -43.24],
                    [43.24, -15.713],
                    [15.712, 43.241]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [1, 0.952999997606, 0.875, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [96.868, 96.772], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 13",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 3,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, -36.28], [36.28, 0], [0, 36.28], [-36.28, 0]],
                  "o": [[0, 36.28], [-36.28, 0], [0, -36.28], [36.28, 0]],
                  "v": [[65.69, 0], [0, 65.69], [-65.69, 0], [0, -65.69]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.313999998803, 0.337000020345, 0.352999997606, 1],
                "ix": 3
              },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 12.452, "ix": 5 },
              "lc": 1,
              "lj": 1,
              "ml": 10,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.536999990426, 0.607999973671, 0.647000002394, 1],
                "ix": 4
              },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [96.82, 96.82], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 14",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 4,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, -6.759], [6.759, 0], [0, 6.759], [-6.759, 0]],
                  "o": [[0, 6.759], [-6.759, 0], [0, -6.759], [6.759, 0]],
                  "v": [[12.239, 0], [0, 12.239], [-12.239, 0], [0, -12.239]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.536999990426, 0.607999973671, 0.647000002394, 1],
                "ix": 4
              },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [179.803, 51.559], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 20",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 5,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, -6.759], [6.759, 0], [0, 6.759], [-6.759, 0]],
                  "o": [[0, 6.759], [-6.759, 0], [0, -6.759], [6.759, 0]],
                  "v": [[12.239, 0], [0, 12.239], [-12.239, 0], [0, -12.239]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.536999990426, 0.607999973671, 0.647000002394, 1],
                "ix": 4
              },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [179.803, 51.559], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 15",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 6,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [0, 0]],
                  "o": [[0, 0], [0, 0]],
                  "v": [[22.04, 11.807], [-22.04, -11.807]],
                  "c": false
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.275, 0.289999988032, 0.298000021542, 1],
                "ix": 3
              },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 36.414, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [201.712, 60.838], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 16",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 7,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [0, 0]],
                  "o": [[0, 0], [0, 0]],
                  "v": [[-22.04, 11.807], [22.04, -11.807]],
                  "c": false
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.275, 0.289999988032, 0.298000021542, 1],
                "ix": 3
              },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 36.414, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [156.976, 60.838], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 17",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 8,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, -37.584], [-37.584, 0], [0, 37.584], [37.584, 0]],
                  "o": [[0, 37.584], [37.584, 0], [0, -37.584], [-37.584, 0]],
                  "v": [[-68.052, 0], [0, 68.052], [68.052, 0], [0, -68.052]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [1, 0.681999954523, 0.263000009574, 1],
                "ix": 4
              },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 49,
                    "s": [268.953, 112.129],
                    "to": [0, 0],
                    "ti": [0, 0]
                  },
                  {
                    "i": { "x": 0.667, "y": 0.667 },
                    "o": { "x": 0.333, "y": 0.333 },
                    "t": 59,
                    "s": [257.953, 99.129],
                    "to": [0, 0],
                    "ti": [0, 0]
                  },
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 77,
                    "s": [257.953, 99.129],
                    "to": [0, 0],
                    "ti": [0, 0]
                  },
                  { "t": 87, "s": [268.953, 112.129] }
                ],
                "ix": 2
              },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 18",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 9,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, -37.584], [37.584, 0], [0, 37.584], [-37.584, 0]],
                  "o": [[0, 37.584], [-37.584, 0], [0, -37.584], [37.584, 0]],
                  "v": [[68.052, 0], [0, 68.052], [-68.052, 0], [0, -68.052]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [1, 0.681999954523, 0.263000009574, 1],
                "ix": 4
              },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 49,
                    "s": [87.758, 112.129],
                    "to": [0, 0],
                    "ti": [0, 0]
                  },
                  {
                    "i": { "x": 0.667, "y": 0.667 },
                    "o": { "x": 0.333, "y": 0.333 },
                    "t": 59,
                    "s": [96.758, 97.129],
                    "to": [0, 0],
                    "ti": [0, 0]
                  },
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 77,
                    "s": [96.758, 97.129],
                    "to": [0, 0],
                    "ti": [0, 0]
                  },
                  { "t": 87, "s": [87.758, 112.129] }
                ],
                "ix": 2
              },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 19",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 10,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 150,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 9,
      "ty": 4,
      "nm": "nose Outlines",
      "parent": 16,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": {
          "a": 1,
          "k": [
            {
              "i": { "x": 0.667, "y": 1 },
              "o": { "x": 0.333, "y": 0 },
              "t": 49,
              "s": [169.726, 171.817, 0],
              "to": [0, -2, 0],
              "ti": [0, 2, 0]
            },
            {
              "i": { "x": 0.667, "y": 0.667 },
              "o": { "x": 0.333, "y": 0.333 },
              "t": 53,
              "s": [169.726, 159.817, 0],
              "to": [0, 0, 0],
              "ti": [0, 0, 0]
            },
            {
              "i": { "x": 0.667, "y": 1 },
              "o": { "x": 0.333, "y": 0 },
              "t": 77,
              "s": [169.726, 159.817, 0],
              "to": [0, 2, 0],
              "ti": [0, -2, 0]
            },
            { "t": 81, "s": [169.726, 171.817, 0] }
          ],
          "ix": 2,
          "l": 2
        },
        "a": { "a": 0, "k": [34.911, 27.645, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, 0], [0, 0]],
                  "o": [[0, 0], [0, 0]],
                  "v": [[34.055, 36.913], [51.953, 36.913]],
                  "c": false
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": {
                "a": 0,
                "k": [0.136999990426, 0.226999993418, 0.33300000359, 1],
                "ix": 3
              },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 2.988, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-1.882, 1.528],
                    [-3.691, 1.022],
                    [1.13, 1.528],
                    [5.702, 0.007],
                    [3.737, -5.029],
                    [-1.83, -0.512],
                    [-2.854, -2.329]
                  ],
                  "o": [
                    [2.86, -2.322],
                    [1.832, -0.507],
                    [-3.724, -5.038],
                    [-5.701, -0.007],
                    [-1.133, 1.525],
                    [3.689, 1.03],
                    [1.878, 1.532]
                  ],
                  "v": [
                    [3.192, 8.001],
                    [13.11, 2.898],
                    [14.592, -1.355],
                    [0.011, -9.523],
                    [-14.589, -1.391],
                    [-13.118, 2.865],
                    [-3.212, 7.993]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.136999990426, 0.226999993418, 0.33300000359, 1],
                "ix": 4
              },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [35.87, 19.3], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 2",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 2,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[0, -15.13], [19.143, 0], [0, 15.13], [-19.143, 0]],
                  "o": [[0, 15.13], [-19.143, 0], [0, -15.13], [19.143, 0]],
                  "v": [[34.661, 0], [0, 27.395], [-34.661, 0], [0, -27.395]],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [1, 0.952999997606, 0.875, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [34.911, 27.645], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 3",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 3,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 150,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 10,
      "ty": 4,
      "nm": "hand-left Outlines",
      "parent": 22,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": {
          "a": 1,
          "k": [
            {
              "i": { "x": [0.667], "y": [1] },
              "o": { "x": [0.333], "y": [0] },
              "t": 0,
              "s": [0]
            },
            {
              "i": { "x": [0.667], "y": [1] },
              "o": { "x": [0.333], "y": [0] },
              "t": 7,
              "s": [-8]
            },
            {
              "i": { "x": [0.667], "y": [1] },
              "o": { "x": [0.333], "y": [0] },
              "t": 49,
              "s": [-8]
            },
            { "t": 56, "s": [0] }
          ],
          "ix": 10
        },
        "p": { "a": 0, "k": [50.815, 3.646, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [100.086, 111.525, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 49,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-12.079, -1.625]
                        ],
                        "o": [[0, 0], [0, 0], [0, 0], [1.625, -12.079], [0, 0]],
                        "v": [
                          [14.283, -13.998],
                          [10.249, 15.98],
                          [-14.283, 12.679],
                          [-13.193, 4.573],
                          [11.621, -14.355]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 59,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-12.079, -1.625]
                        ],
                        "o": [[0, 0], [0, 0], [0, 0], [1.625, -12.079], [0, 0]],
                        "v": [
                          [0.82, 82.679],
                          [-3.213, 112.657],
                          [-27.745, 109.356],
                          [-26.655, 101.25],
                          [-1.841, 82.321]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 77,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-12.079, -1.625]
                        ],
                        "o": [[0, 0], [0, 0], [0, 0], [1.625, -12.079], [0, 0]],
                        "v": [
                          [0.82, 82.679],
                          [-3.213, 112.657],
                          [-27.745, 109.356],
                          [-26.655, 101.25],
                          [-1.841, 82.321]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "t": 87,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-12.079, -1.625]
                        ],
                        "o": [[0, 0], [0, 0], [0, 0], [1.625, -12.079], [0, 0]],
                        "v": [
                          [14.283, -13.998],
                          [10.249, 15.98],
                          [-14.283, 12.679],
                          [-13.193, 4.573],
                          [11.621, -14.355]
                        ],
                        "c": true
                      }
                    ]
                  }
                ],
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.136999990426, 0.226999993418, 0.33300000359, 1],
                "ix": 4
              },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [20.644, 16.231], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 49,
                    "s": [
                      {
                        "i": [
                          [-2.784, -0.375],
                          [-0.305, 2.264],
                          [2.783, 0.374],
                          [0.304, -2.263]
                        ],
                        "o": [
                          [2.784, 0.374],
                          [0.304, -2.263],
                          [-2.784, -0.375],
                          [-0.305, 2.263]
                        ],
                        "v": [
                          [-0.551, 4.098],
                          [5.041, 0.678],
                          [0.552, -4.097],
                          [-5.04, -0.678]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 59,
                    "s": [
                      {
                        "i": [
                          [-2.784, -0.375],
                          [-0.305, 2.264],
                          [2.783, 0.374],
                          [0.304, -2.263]
                        ],
                        "o": [
                          [2.784, 0.374],
                          [0.304, -2.263],
                          [-2.784, -0.375],
                          [-0.305, 2.263]
                        ],
                        "v": [
                          [-14.014, 100.775],
                          [-8.422, 97.355],
                          [-12.911, 92.58],
                          [-18.503, 95.999]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 77,
                    "s": [
                      {
                        "i": [
                          [-2.784, -0.375],
                          [-0.305, 2.264],
                          [2.783, 0.374],
                          [0.304, -2.263]
                        ],
                        "o": [
                          [2.784, 0.374],
                          [0.304, -2.263],
                          [-2.784, -0.375],
                          [-0.305, 2.263]
                        ],
                        "v": [
                          [-14.014, 100.775],
                          [-8.422, 97.355],
                          [-12.911, 92.58],
                          [-18.503, 95.999]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "t": 87,
                    "s": [
                      {
                        "i": [
                          [-2.784, -0.375],
                          [-0.305, 2.264],
                          [2.783, 0.374],
                          [0.304, -2.263]
                        ],
                        "o": [
                          [2.784, 0.374],
                          [0.304, -2.263],
                          [-2.784, -0.375],
                          [-0.305, 2.263]
                        ],
                        "v": [
                          [-0.551, 4.098],
                          [5.041, 0.678],
                          [0.552, -4.097],
                          [-5.04, -0.678]
                        ],
                        "c": true
                      }
                    ]
                  }
                ],
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.136999990426, 0.226999993418, 0.33300000359, 1],
                "ix": 4
              },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [32.17, 22.721], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 2",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 2,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 49,
                    "s": [
                      {
                        "i": [
                          [-2.784, -0.374],
                          [-0.305, 2.264],
                          [2.783, 0.374],
                          [0.304, -2.263]
                        ],
                        "o": [
                          [2.784, 0.375],
                          [0.304, -2.263],
                          [-2.784, -0.375],
                          [-0.305, 2.263]
                        ],
                        "v": [
                          [-0.551, 4.097],
                          [5.041, 0.678],
                          [0.552, -4.097],
                          [-5.04, -0.678]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 59,
                    "s": [
                      {
                        "i": [
                          [-2.784, -0.374],
                          [-0.305, 2.264],
                          [2.783, 0.374],
                          [0.304, -2.263]
                        ],
                        "o": [
                          [2.784, 0.375],
                          [0.304, -2.263],
                          [-2.784, -0.375],
                          [-0.305, 2.263]
                        ],
                        "v": [
                          [-14.014, 100.774],
                          [-8.422, 97.354],
                          [-12.911, 92.579],
                          [-18.503, 95.998]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 77,
                    "s": [
                      {
                        "i": [
                          [-2.784, -0.374],
                          [-0.305, 2.264],
                          [2.783, 0.374],
                          [0.304, -2.263]
                        ],
                        "o": [
                          [2.784, 0.375],
                          [0.304, -2.263],
                          [-2.784, -0.375],
                          [-0.305, 2.263]
                        ],
                        "v": [
                          [-14.014, 100.774],
                          [-8.422, 97.354],
                          [-12.911, 92.579],
                          [-18.503, 95.998]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "t": 87,
                    "s": [
                      {
                        "i": [
                          [-2.784, -0.374],
                          [-0.305, 2.264],
                          [2.783, 0.374],
                          [0.304, -2.263]
                        ],
                        "o": [
                          [2.784, 0.375],
                          [0.304, -2.263],
                          [-2.784, -0.375],
                          [-0.305, 2.263]
                        ],
                        "v": [
                          [-0.551, 4.097],
                          [5.041, 0.678],
                          [0.552, -4.097],
                          [-5.04, -0.678]
                        ],
                        "c": true
                      }
                    ]
                  }
                ],
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.136999990426, 0.226999993418, 0.33300000359, 1],
                "ix": 4
              },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [33.272, 14.526], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 3",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 3,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 49,
                    "s": [
                      {
                        "i": [
                          [-2.784, -0.375],
                          [-0.305, 2.264],
                          [2.783, 0.374],
                          [0.304, -2.263]
                        ],
                        "o": [
                          [2.784, 0.375],
                          [0.304, -2.263],
                          [-2.784, -0.375],
                          [-0.305, 2.263]
                        ],
                        "v": [
                          [-0.551, 4.097],
                          [5.041, 0.678],
                          [0.552, -4.097],
                          [-5.04, -0.678]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 59,
                    "s": [
                      {
                        "i": [
                          [-2.784, -0.375],
                          [-0.305, 2.264],
                          [2.783, 0.374],
                          [0.304, -2.263]
                        ],
                        "o": [
                          [2.784, 0.375],
                          [0.304, -2.263],
                          [-2.784, -0.375],
                          [-0.305, 2.263]
                        ],
                        "v": [
                          [-14.014, 100.774],
                          [-8.422, 97.354],
                          [-12.911, 92.579],
                          [-18.503, 95.998]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 77,
                    "s": [
                      {
                        "i": [
                          [-2.784, -0.375],
                          [-0.305, 2.264],
                          [2.783, 0.374],
                          [0.304, -2.263]
                        ],
                        "o": [
                          [2.784, 0.375],
                          [0.304, -2.263],
                          [-2.784, -0.375],
                          [-0.305, 2.263]
                        ],
                        "v": [
                          [-14.014, 100.774],
                          [-8.422, 97.354],
                          [-12.911, 92.579],
                          [-18.503, 95.998]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "t": 87,
                    "s": [
                      {
                        "i": [
                          [-2.784, -0.375],
                          [-0.305, 2.264],
                          [2.783, 0.374],
                          [0.304, -2.263]
                        ],
                        "o": [
                          [2.784, 0.375],
                          [0.304, -2.263],
                          [-2.784, -0.375],
                          [-0.305, 2.263]
                        ],
                        "v": [
                          [-0.551, 4.097],
                          [5.041, 0.678],
                          [0.552, -4.097],
                          [-5.04, -0.678]
                        ],
                        "c": true
                      }
                    ]
                  }
                ],
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.136999990426, 0.226999993418, 0.33300000359, 1],
                "ix": 4
              },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [34.375, 6.331], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 4",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 4,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 49,
                    "s": [
                      {
                        "i": [[-1.114, 8.278], [-7.692, -1.035], [0, 0]],
                        "o": [[1.114, -8.278], [0, 0], [-7.692, -1.034]],
                        "v": [
                          [-7.415, -1.356],
                          [8.529, -14.471],
                          [4.496, 15.506]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 59,
                    "s": [
                      {
                        "i": [[-1.114, 8.278], [-7.692, -1.035], [0, 0]],
                        "o": [[1.114, -8.278], [0, 0], [-7.692, -1.034]],
                        "v": [
                          [-20.878, 95.321],
                          [-4.934, 82.206],
                          [-8.967, 112.183]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 77,
                    "s": [
                      {
                        "i": [[-1.114, 8.278], [-7.692, -1.035], [0, 0]],
                        "o": [[1.114, -8.278], [0, 0], [-7.692, -1.034]],
                        "v": [
                          [-20.878, 95.321],
                          [-4.934, 82.206],
                          [-8.967, 112.183]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "t": 87,
                    "s": [
                      {
                        "i": [[-1.114, 8.278], [-7.692, -1.035], [0, 0]],
                        "o": [[1.114, -8.278], [0, 0], [-7.692, -1.034]],
                        "v": [
                          [-7.415, -1.356],
                          [8.529, -14.471],
                          [4.496, 15.506]
                        ],
                        "c": true
                      }
                    ]
                  }
                ],
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.136999990426, 0.226999993418, 0.33300000359, 1],
                "ix": 4
              },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [26.397, 16.704], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 5",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 5,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 49,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [-47.778, -25.867],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [3.127, 37.91]
                        ],
                        "o": [
                          [0, 0],
                          [-6.111, 53.986],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-36.453, -10.872],
                          [0, 0]
                        ],
                        "v": [
                          [-44.725, -67.899],
                          [-44.725, -67.899],
                          [24.226, 64.242],
                          [34.842, 69.99],
                          [50.836, 12.298],
                          [46.168, 10.906],
                          [-19.467, -69.99]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 59,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [-21.514, 22.122],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [3.127, 37.91]
                        ],
                        "o": [
                          [0, 0],
                          [-6.111, 53.986],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-36.453, -10.872],
                          [0, 0]
                        ],
                        "v": [
                          [-58.188, 29.744],
                          [-58.188, 29.744],
                          [31.993, 90.345],
                          [34.842, 69.99],
                          [50.836, 12.298],
                          [46.168, 10.906],
                          [-32.93, 27.654]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 77,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [-21.514, 22.122],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [3.127, 37.91]
                        ],
                        "o": [
                          [0, 0],
                          [-6.111, 53.986],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-36.453, -10.872],
                          [0, 0]
                        ],
                        "v": [
                          [-58.188, 29.744],
                          [-58.188, 29.744],
                          [31.993, 90.345],
                          [34.842, 69.99],
                          [50.836, 12.298],
                          [46.168, 10.906],
                          [-32.93, 27.654]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "t": 87,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [-47.778, -25.867],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [3.127, 37.91]
                        ],
                        "o": [
                          [0, 0],
                          [-6.111, 53.986],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-36.453, -10.872],
                          [0, 0]
                        ],
                        "v": [
                          [-44.725, -67.899],
                          [-44.725, -67.899],
                          [24.226, 64.242],
                          [34.842, 69.99],
                          [50.836, 12.298],
                          [46.168, 10.906],
                          [-19.467, -69.99]
                        ],
                        "c": true
                      }
                    ]
                  }
                ],
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [1, 0.725, 0.313999998803, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [51.086, 96.809], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 6",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 6,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 150,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 11,
      "ty": 4,
      "nm": "hand-right Outlines",
      "parent": 22,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": {
          "a": 1,
          "k": [
            {
              "i": { "x": [0.667], "y": [1] },
              "o": { "x": [0.333], "y": [0] },
              "t": 0,
              "s": [0]
            },
            {
              "i": { "x": [0.667], "y": [1] },
              "o": { "x": [0.333], "y": [0] },
              "t": 7,
              "s": [8]
            },
            {
              "i": { "x": [0.667], "y": [1] },
              "o": { "x": [0.333], "y": [0] },
              "t": 49,
              "s": [8]
            },
            { "t": 56, "s": [0] }
          ],
          "ix": 10
        },
        "p": { "a": 0, "k": [201.14, 1.646, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [5.086, 109.525, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 49,
                    "s": [
                      {
                        "i": [[0, 0], [0, 0], [0, 0], [0, 0], [12.079, -1.625]],
                        "o": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-1.625, -12.079],
                          [0, 0]
                        ],
                        "v": [
                          [-14.282, -13.998],
                          [-10.25, 15.98],
                          [14.282, 12.679],
                          [13.193, 4.573],
                          [-11.622, -14.355]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 59,
                    "s": [
                      {
                        "i": [[0, 0], [0, 0], [0, 0], [0, 0], [12.079, -1.625]],
                        "o": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-1.625, -12.079],
                          [0, 0]
                        ],
                        "v": [
                          [3.323, 84.613],
                          [7.356, 114.591],
                          [31.888, 111.29],
                          [30.798, 103.184],
                          [5.984, 84.255]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 77,
                    "s": [
                      {
                        "i": [[0, 0], [0, 0], [0, 0], [0, 0], [12.079, -1.625]],
                        "o": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-1.625, -12.079],
                          [0, 0]
                        ],
                        "v": [
                          [3.323, 84.613],
                          [7.356, 114.591],
                          [31.888, 111.29],
                          [30.798, 103.184],
                          [5.984, 84.255]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "t": 87,
                    "s": [
                      {
                        "i": [[0, 0], [0, 0], [0, 0], [0, 0], [12.079, -1.625]],
                        "o": [
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-1.625, -12.079],
                          [0, 0]
                        ],
                        "v": [
                          [-14.282, -13.998],
                          [-10.25, 15.98],
                          [14.282, 12.679],
                          [13.193, 4.573],
                          [-11.622, -14.355]
                        ],
                        "c": true
                      }
                    ]
                  }
                ],
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.136999990426, 0.226999993418, 0.33300000359, 1],
                "ix": 4
              },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [81.528, 16.231], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 49,
                    "s": [
                      {
                        "i": [
                          [2.784, -0.375],
                          [0.305, 2.264],
                          [-2.783, 0.374],
                          [-0.304, -2.263]
                        ],
                        "o": [
                          [-2.784, 0.374],
                          [-0.304, -2.263],
                          [2.784, -0.375],
                          [0.305, 2.263]
                        ],
                        "v": [
                          [0.551, 4.098],
                          [-5.041, 0.678],
                          [-0.552, -4.097],
                          [5.04, -0.678]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 59,
                    "s": [
                      {
                        "i": [
                          [2.784, -0.375],
                          [0.305, 2.264],
                          [-2.783, 0.374],
                          [-0.304, -2.263]
                        ],
                        "o": [
                          [-2.784, 0.374],
                          [-0.304, -2.263],
                          [2.784, -0.375],
                          [0.305, 2.263]
                        ],
                        "v": [
                          [18.156, 102.708],
                          [12.564, 99.288],
                          [17.053, 94.513],
                          [22.645, 97.932]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 77,
                    "s": [
                      {
                        "i": [
                          [2.784, -0.375],
                          [0.305, 2.264],
                          [-2.783, 0.374],
                          [-0.304, -2.263]
                        ],
                        "o": [
                          [-2.784, 0.374],
                          [-0.304, -2.263],
                          [2.784, -0.375],
                          [0.305, 2.263]
                        ],
                        "v": [
                          [18.156, 102.708],
                          [12.564, 99.288],
                          [17.053, 94.513],
                          [22.645, 97.932]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "t": 87,
                    "s": [
                      {
                        "i": [
                          [2.784, -0.375],
                          [0.305, 2.264],
                          [-2.783, 0.374],
                          [-0.304, -2.263]
                        ],
                        "o": [
                          [-2.784, 0.374],
                          [-0.304, -2.263],
                          [2.784, -0.375],
                          [0.305, 2.263]
                        ],
                        "v": [
                          [0.551, 4.098],
                          [-5.041, 0.678],
                          [-0.552, -4.097],
                          [5.04, -0.678]
                        ],
                        "c": true
                      }
                    ]
                  }
                ],
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.136999990426, 0.226999993418, 0.33300000359, 1],
                "ix": 4
              },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [70.002, 22.721], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 2",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 2,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 49,
                    "s": [
                      {
                        "i": [
                          [2.784, -0.374],
                          [0.305, 2.264],
                          [-2.783, 0.374],
                          [-0.304, -2.263]
                        ],
                        "o": [
                          [-2.784, 0.375],
                          [-0.304, -2.263],
                          [2.784, -0.375],
                          [0.305, 2.263]
                        ],
                        "v": [
                          [0.551, 4.097],
                          [-5.041, 0.678],
                          [-0.552, -4.097],
                          [5.04, -0.678]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 59,
                    "s": [
                      {
                        "i": [
                          [2.784, -0.374],
                          [0.305, 2.264],
                          [-2.783, 0.374],
                          [-0.304, -2.263]
                        ],
                        "o": [
                          [-2.784, 0.375],
                          [-0.304, -2.263],
                          [2.784, -0.375],
                          [0.305, 2.263]
                        ],
                        "v": [
                          [18.156, 102.708],
                          [12.564, 99.288],
                          [17.053, 94.513],
                          [22.645, 97.932]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 77,
                    "s": [
                      {
                        "i": [
                          [2.784, -0.374],
                          [0.305, 2.264],
                          [-2.783, 0.374],
                          [-0.304, -2.263]
                        ],
                        "o": [
                          [-2.784, 0.375],
                          [-0.304, -2.263],
                          [2.784, -0.375],
                          [0.305, 2.263]
                        ],
                        "v": [
                          [18.156, 102.708],
                          [12.564, 99.288],
                          [17.053, 94.513],
                          [22.645, 97.932]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "t": 87,
                    "s": [
                      {
                        "i": [
                          [2.784, -0.374],
                          [0.305, 2.264],
                          [-2.783, 0.374],
                          [-0.304, -2.263]
                        ],
                        "o": [
                          [-2.784, 0.375],
                          [-0.304, -2.263],
                          [2.784, -0.375],
                          [0.305, 2.263]
                        ],
                        "v": [
                          [0.551, 4.097],
                          [-5.041, 0.678],
                          [-0.552, -4.097],
                          [5.04, -0.678]
                        ],
                        "c": true
                      }
                    ]
                  }
                ],
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.136999990426, 0.226999993418, 0.33300000359, 1],
                "ix": 4
              },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [68.9, 14.526], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 3",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 3,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 49,
                    "s": [
                      {
                        "i": [
                          [2.784, -0.375],
                          [0.305, 2.264],
                          [-2.783, 0.374],
                          [-0.304, -2.263]
                        ],
                        "o": [
                          [-2.784, 0.375],
                          [-0.304, -2.263],
                          [2.784, -0.375],
                          [0.305, 2.263]
                        ],
                        "v": [
                          [0.551, 4.097],
                          [-5.041, 0.678],
                          [-0.552, -4.097],
                          [5.04, -0.678]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 59,
                    "s": [
                      {
                        "i": [
                          [2.784, -0.375],
                          [0.305, 2.264],
                          [-2.783, 0.374],
                          [-0.304, -2.263]
                        ],
                        "o": [
                          [-2.784, 0.375],
                          [-0.304, -2.263],
                          [2.784, -0.375],
                          [0.305, 2.263]
                        ],
                        "v": [
                          [18.156, 102.708],
                          [12.564, 99.288],
                          [17.053, 94.513],
                          [22.645, 97.932]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 77,
                    "s": [
                      {
                        "i": [
                          [2.784, -0.375],
                          [0.305, 2.264],
                          [-2.783, 0.374],
                          [-0.304, -2.263]
                        ],
                        "o": [
                          [-2.784, 0.375],
                          [-0.304, -2.263],
                          [2.784, -0.375],
                          [0.305, 2.263]
                        ],
                        "v": [
                          [18.156, 102.708],
                          [12.564, 99.288],
                          [17.053, 94.513],
                          [22.645, 97.932]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "t": 87,
                    "s": [
                      {
                        "i": [
                          [2.784, -0.375],
                          [0.305, 2.264],
                          [-2.783, 0.374],
                          [-0.304, -2.263]
                        ],
                        "o": [
                          [-2.784, 0.375],
                          [-0.304, -2.263],
                          [2.784, -0.375],
                          [0.305, 2.263]
                        ],
                        "v": [
                          [0.551, 4.097],
                          [-5.041, 0.678],
                          [-0.552, -4.097],
                          [5.04, -0.678]
                        ],
                        "c": true
                      }
                    ]
                  }
                ],
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.136999990426, 0.226999993418, 0.33300000359, 1],
                "ix": 4
              },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [67.797, 6.331], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 4",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 4,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 49,
                    "s": [
                      {
                        "i": [[1.114, 8.278], [7.692, -1.035], [0, 0]],
                        "o": [[-1.114, -8.278], [0, 0], [7.692, -1.034]],
                        "v": [
                          [7.415, -1.356],
                          [-8.529, -14.471],
                          [-4.496, 15.506]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 59,
                    "s": [
                      {
                        "i": [[1.114, 8.278], [7.692, -1.035], [0, 0]],
                        "o": [[-1.114, -8.278], [0, 0], [7.692, -1.034]],
                        "v": [
                          [25.02, 97.254],
                          [9.076, 84.139],
                          [13.109, 114.116]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 77,
                    "s": [
                      {
                        "i": [[1.114, 8.278], [7.692, -1.035], [0, 0]],
                        "o": [[-1.114, -8.278], [0, 0], [7.692, -1.034]],
                        "v": [
                          [25.02, 97.254],
                          [9.076, 84.139],
                          [13.109, 114.116]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "t": 87,
                    "s": [
                      {
                        "i": [[1.114, 8.278], [7.692, -1.035], [0, 0]],
                        "o": [[-1.114, -8.278], [0, 0], [7.692, -1.034]],
                        "v": [
                          [7.415, -1.356],
                          [-8.529, -14.471],
                          [-4.496, 15.506]
                        ],
                        "c": true
                      }
                    ]
                  }
                ],
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.136999990426, 0.226999993418, 0.33300000359, 1],
                "ix": 4
              },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [75.775, 16.704], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 5",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 5,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 49,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [47.778, -25.867],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-3.127, 37.91]
                        ],
                        "o": [
                          [0, 0],
                          [6.111, 53.986],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [36.453, -10.872],
                          [0, 0]
                        ],
                        "v": [
                          [44.725, -67.899],
                          [44.725, -67.899],
                          [-24.226, 64.242],
                          [-34.842, 69.99],
                          [-50.836, 12.298],
                          [-46.168, 10.906],
                          [19.467, -69.99]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 59,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [24.979, 4.237],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-3.127, 37.91]
                        ],
                        "o": [
                          [0, 0],
                          [-3.843, 52.027],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [36.453, -10.872],
                          [0, 0]
                        ],
                        "v": [
                          [62.071, 31.195],
                          [62.33, 31.195],
                          [-30.957, 99.046],
                          [-45.198, 68.54],
                          [-50.836, 12.298],
                          [-46.168, 10.906],
                          [36.813, 29.104]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 77,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [24.979, 4.237],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-3.127, 37.91]
                        ],
                        "o": [
                          [0, 0],
                          [-3.843, 52.027],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [36.453, -10.872],
                          [0, 0]
                        ],
                        "v": [
                          [62.071, 31.195],
                          [62.33, 31.195],
                          [-30.957, 99.046],
                          [-45.198, 68.54],
                          [-50.836, 12.298],
                          [-46.168, 10.906],
                          [36.813, 29.104]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "t": 87,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [47.778, -25.867],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [-3.127, 37.91]
                        ],
                        "o": [
                          [0, 0],
                          [6.111, 53.986],
                          [0, 0],
                          [0, 0],
                          [0, 0],
                          [36.453, -10.872],
                          [0, 0]
                        ],
                        "v": [
                          [44.725, -67.899],
                          [44.725, -67.899],
                          [-24.226, 64.242],
                          [-34.842, 69.99],
                          [-50.836, 12.298],
                          [-46.168, 10.906],
                          [19.467, -69.99]
                        ],
                        "c": true
                      }
                    ]
                  }
                ],
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [1, 0.725, 0.313999998803, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [51.086, 96.809], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 6",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 6,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 150,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 12,
      "ty": 4,
      "nm": "Group 1",
      "parent": 16,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [168.641, 31.889, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [168.641, 31.889, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-6.101, 6.836],
                    [0, 0],
                    [-0.389, -1.569],
                    [0, 0],
                    [4.875, -3.272],
                    [0, 0],
                    [1.477, 0.047]
                  ],
                  "o": [
                    [0, 0],
                    [1.076, -1.205],
                    [0, 0],
                    [1.415, 5.697],
                    [0, 0],
                    [-1.227, 0.824],
                    [-9.158, -0.291]
                  ],
                  "v": [
                    [-7.666, -1.083],
                    [5.412, -15.736],
                    [8.864, -14.88],
                    [12.352, -0.845],
                    [6.588, 14.098],
                    [4.204, 15.698],
                    [0.044, 16.893]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [1, 0.725, 0.313999998803, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [167.471, 31.644], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 150,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 13,
      "ty": 4,
      "nm": "Group 2",
      "parent": 16,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [183.11, 33.139, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [183.11, 33.139, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-9.914, 2.119],
                    [0, 0],
                    [0.677, -1.655],
                    [0, 0],
                    [6.491, 0.262],
                    [0, 0],
                    [1.289, 1.007],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [1.749, -0.374],
                    [0, 0],
                    [-2.458, 6.013],
                    [0, 0],
                    [-1.635, -0.066],
                    [0, 0],
                    [-7.988, -6.242]
                  ],
                  "v": [
                    [-5.804, -9.108],
                    [15.448, -13.65],
                    [17.973, -10.632],
                    [11.919, 4.181],
                    [-2.99, 13.762],
                    [-6.165, 13.633],
                    [-10.661, 11.982],
                    [-10.662, 11.982]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [1, 0.725, 0.313999998803, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [181.669, 33.102], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 2",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 150,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 14,
      "ty": 4,
      "nm": "eyes",
      "parent": 15,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [170.413, 139.132, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [170.413, 139.132, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 1,
                    "k": [
                      {
                        "i": { "x": 0.833, "y": 0.833 },
                        "o": { "x": 0.167, "y": 0.167 },
                        "t": 62,
                        "s": [
                          {
                            "i": [[-11.261, 0.031], [-2.452, -7.453], [0, 0]],
                            "o": [[11.261, -0.031], [0, 0], [-2.452, -7.453]],
                            "v": [
                              [-1.088, -18.326],
                              [23.741, -4.888],
                              [-17.039, -4.775]
                            ],
                            "c": true
                          }
                        ]
                      },
                      {
                        "t": 66,
                        "s": [
                          {
                            "i": [[-10.99, 4], [-4, -10.99], [0, 0]],
                            "o": [[10.99, -4], [0, 0], [-4, -10.99]],
                            "v": [
                              [-5.242, -11.571],
                              [21.898, 1.085],
                              [-17.898, 15.571]
                            ],
                            "c": true
                          }
                        ]
                      }
                    ],
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": {
                    "a": 0,
                    "k": [0.136999990426, 0.226999993418, 0.33300000359, 1],
                    "ix": 4
                  },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [217.05, 130.219], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 3",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 1,
                    "k": [
                      {
                        "i": { "x": 0.833, "y": 0.833 },
                        "o": { "x": 0.167, "y": 0.167 },
                        "t": 62,
                        "s": [
                          {
                            "i": [[11.57, -0.363], [1.139, -6.831], [0, 0]],
                            "o": [[-11.57, 0.363], [0, 0], [1.138, -6.831]],
                            "v": [
                              [8.043, -13.27],
                              [-14.97, -0.244],
                              [26.931, -1.561]
                            ],
                            "c": true
                          }
                        ]
                      },
                      {
                        "t": 66,
                        "s": [
                          {
                            "i": [[11.517, 2.031], [2.031, -11.518], [0, 0]],
                            "o": [[-11.517, -2.031], [0, 0], [2.03, -11.518]],
                            "v": [
                              [2.662, -11.25],
                              [-21.869, 5.927],
                              [19.839, 13.281]
                            ],
                            "c": true
                          }
                        ]
                      }
                    ],
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": {
                    "a": 0,
                    "k": [0.136999990426, 0.226999993418, 0.33300000359, 1],
                    "ix": 4
                  },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [121.902, 125.609], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 4",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 2,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.284, 1.357],
                        [-1.357, 0.284],
                        [-0.284, -1.356],
                        [1.357, -0.284]
                      ],
                      "o": [
                        [-0.284, -1.357],
                        [1.356, -0.284],
                        [0.283, 1.357],
                        [-1.357, 0.283]
                      ],
                      "v": [
                        [-2.456, 0.514],
                        [-0.513, -2.456],
                        [2.457, -0.514],
                        [0.514, 2.457]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [1, 0.952999997606, 0.875, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [214.681, 152.632], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 5",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 3,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.497, 2.377],
                        [-2.377, 0.498],
                        [-0.497, -2.377],
                        [2.377, -0.497]
                      ],
                      "o": [
                        [-0.497, -2.377],
                        [2.377, -0.497],
                        [0.497, 2.378],
                        [-2.378, 0.497]
                      ],
                      "v": [
                        [-4.304, 0.9],
                        [-0.9, -4.304],
                        [4.304, -0.9],
                        [0.9, 4.305]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [1, 0.952999997606, 0.875, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [227.611, 140.132], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 6",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 4,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [1.157, 5.529],
                        [-5.529, 1.156],
                        [-1.156, -5.529],
                        [5.529, -1.156]
                      ],
                      "o": [
                        [-1.156, -5.529],
                        [5.529, -1.157],
                        [1.157, 5.529],
                        [-5.529, 1.157]
                      ],
                      "v": [
                        [-10.011, 2.094],
                        [-2.094, -10.011],
                        [10.01, -2.094],
                        [2.093, 10.011]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": {
                    "a": 0,
                    "k": [0.136999990426, 0.226999993418, 0.33300000359, 1],
                    "ix": 4
                  },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [222.108, 145.546], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 7",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 5,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [2.112, 10.099],
                        [-10.099, 2.113],
                        [-2.113, -10.099],
                        [10.099, -2.112]
                      ],
                      "o": [
                        [-2.112, -10.099],
                        [10.099, -2.112],
                        [2.112, 10.099],
                        [-10.099, 2.112]
                      ],
                      "v": [
                        [-18.286, 3.825],
                        [-3.825, -18.286],
                        [18.286, -3.825],
                        [3.825, 18.286]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [1, 0.952999997606, 0.875, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [222.108, 145.545], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 8",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 6,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.284, 1.357],
                        [-1.357, 0.284],
                        [-0.284, -1.356],
                        [1.357, -0.284]
                      ],
                      "o": [
                        [-0.284, -1.357],
                        [1.356, -0.284],
                        [0.283, 1.357],
                        [-1.357, 0.283]
                      ],
                      "v": [
                        [-2.456, 0.514],
                        [-0.513, -2.456],
                        [2.457, -0.514],
                        [0.514, 2.457]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [1, 0.952999997606, 0.875, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [115.24, 152.632], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 9",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 7,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.497, 2.377],
                        [-2.377, 0.498],
                        [-0.497, -2.377],
                        [2.377, -0.497]
                      ],
                      "o": [
                        [-0.497, -2.377],
                        [2.377, -0.497],
                        [0.497, 2.378],
                        [-2.378, 0.497]
                      ],
                      "v": [
                        [-4.304, 0.9],
                        [-0.9, -4.304],
                        [4.304, -0.9],
                        [0.9, 4.305]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [1, 0.952999997606, 0.875, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [128.171, 140.132], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 10",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 8,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [1.156, 5.529],
                        [-5.529, 1.156],
                        [-1.156, -5.529],
                        [5.529, -1.156]
                      ],
                      "o": [
                        [-1.157, -5.529],
                        [5.529, -1.157],
                        [1.157, 5.529],
                        [-5.529, 1.157]
                      ],
                      "v": [
                        [-10.011, 2.094],
                        [-2.094, -10.011],
                        [10.011, -2.094],
                        [2.094, 10.011]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": {
                    "a": 0,
                    "k": [0.136999990426, 0.226999993418, 0.33300000359, 1],
                    "ix": 4
                  },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [122.668, 145.546], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 11",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 9,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [2.112, 10.099],
                        [-10.099, 2.113],
                        [-2.113, -10.099],
                        [10.099, -2.112]
                      ],
                      "o": [
                        [-2.112, -10.099],
                        [10.099, -2.112],
                        [2.112, 10.099],
                        [-10.099, 2.112]
                      ],
                      "v": [
                        [-18.286, 3.825],
                        [-3.825, -18.286],
                        [18.286, -3.825],
                        [3.825, 18.286]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [1, 0.952999997606, 0.875, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [122.668, 145.545], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 12",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 10,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [170.413, 139.132], "ix": 2 },
              "a": { "a": 0, "k": [170.413, 139.132], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 24",
          "np": 10,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 150,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 15,
      "ty": 4,
      "nm": "cheeks",
      "parent": 9,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": {
          "a": 1,
          "k": [
            {
              "i": { "x": 0.667, "y": 1 },
              "o": { "x": 0.333, "y": 0 },
              "t": 49,
              "s": [35.557, 0.69, 0],
              "to": [0, 0.667, 0],
              "ti": [0, -0.667, 0]
            },
            {
              "i": { "x": 0.667, "y": 0.667 },
              "o": { "x": 0.333, "y": 0.333 },
              "t": 53,
              "s": [35.557, 4.69, 0],
              "to": [0, 0, 0],
              "ti": [0, 0, 0]
            },
            {
              "i": { "x": 0.667, "y": 1 },
              "o": { "x": 0.333, "y": 0 },
              "t": 77,
              "s": [35.557, 4.69, 0],
              "to": [0, -0.667, 0],
              "ti": [0, 0.667, 0]
            },
            { "t": 81, "s": [35.557, 0.69, 0] }
          ],
          "ix": 2,
          "l": 2
        },
        "a": { "a": 0, "k": [170.371, 144.861, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [4.414, 3.017],
                        [0, 0],
                        [-2.721, -23.104]
                      ],
                      "o": [
                        [0, 0],
                        [5.311, -0.626],
                        [0, 0],
                        [-19.206, -13.127],
                        [0, 0]
                      ],
                      "v": [
                        [-51.046, 41.308],
                        [51.941, 29.18],
                        [54.528, 18.66],
                        [-14.003, -28.182],
                        [-56.221, -2.631]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": {
                    "a": 0,
                    "k": [0.136999990426, 0.226999993418, 0.33300000359, 1],
                    "ix": 4
                  },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [246.397, 141.973], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 13",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [13.251, -1.558],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [2.589, 15.01],
                        [-3.904, 6.696],
                        [0, 0],
                        [-23.002, -15.698],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-17.378, 2.044],
                        [-1.153, -6.636],
                        [0, 0],
                        [14.06, -24.033],
                        [0, 0],
                        [11.026, 7.526]
                      ],
                      "v": [
                        [74.771, 39.347],
                        [58.202, 41.29],
                        [52.659, 41.957],
                        [26.947, 44.972],
                        [-57.332, 54.904],
                        [-91.096, 29.617],
                        [-87.293, 9.103],
                        [-66.82, -25.855],
                        [1.74, -41.25],
                        [81.223, 13.088]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [1, 0.952999997606, 0.875, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [248.246, 134.072], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 14",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 2,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [-4.414, 3.017],
                        [0, 0],
                        [2.72, -23.104]
                      ],
                      "o": [
                        [0, 0],
                        [-5.311, -0.626],
                        [0, 0],
                        [19.206, -13.127],
                        [0, 0]
                      ],
                      "v": [
                        [51.047, 41.308],
                        [-51.94, 29.18],
                        [-54.528, 18.66],
                        [14.004, -28.182],
                        [56.222, -2.631]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": {
                    "a": 0,
                    "k": [0.136999990426, 0.226999993418, 0.33300000359, 1],
                    "ix": 4
                  },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [100.623, 141.973], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 15",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 3,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [20.209, 2.38],
                        [0, 0],
                        [-11.02, 7.533],
                        [0, 0],
                        [-14.071, -24.036],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [-13.257, -1.561],
                        [0, 0],
                        [22.994, -15.717],
                        [0, 0],
                        [10.279, 17.561]
                      ],
                      "v": [
                        [63.472, 55.435],
                        [-80.425, 38.49],
                        [-86.885, 12.225],
                        [-7.403, -42.099],
                        [61.159, -26.708],
                        [87.626, 18.505]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [1, 0.952999997606, 0.875, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [98.155, 134.93], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 16",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 4,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, -18.185],
                        [23.01, 0],
                        [0, 18.185],
                        [-23.009, 0]
                      ],
                      "o": [
                        [0, 18.185],
                        [-23.009, 0],
                        [0, -18.185],
                        [23.01, 0]
                      ],
                      "v": [
                        [41.661, 0],
                        [-0.001, 32.927],
                        [-41.661, 0],
                        [-0.001, -32.927]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": {
                    "a": 0,
                    "k": [1, 0.681999954523, 0.263000009574, 1],
                    "ix": 4
                  },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [171.368, 172.35], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 17",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 5,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [170.371, 144.861], "ix": 2 },
              "a": { "a": 0, "k": [170.371, 144.861], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 25",
          "np": 5,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 150,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 16,
      "ty": 4,
      "nm": "HEAD",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": {
          "a": 1,
          "k": [
            {
              "i": { "x": 0.667, "y": 1 },
              "o": { "x": 0.333, "y": 0 },
              "t": 42,
              "s": [391.574, 207.162, 0],
              "to": [0, 1.5, 0],
              "ti": [0, 1.833, 0]
            },
            {
              "i": { "x": 0.667, "y": 1 },
              "o": { "x": 0.333, "y": 0 },
              "t": 50,
              "s": [391.574, 216.162, 0],
              "to": [0, -1.833, 0],
              "ti": [0, 3.333, 0]
            },
            { "t": 59, "s": [391.574, 196.162, 0], "h": 1 },
            {
              "i": { "x": 0.667, "y": 1 },
              "o": { "x": 0.333, "y": 0 },
              "t": 77,
              "s": [391.574, 196.162, 0],
              "to": [0, 1.833, 0],
              "ti": [0, -1.833, 0]
            },
            { "t": 81, "s": [391.574, 207.162, 0] }
          ],
          "ix": 2,
          "l": 2
        },
        "a": { "a": 0, "k": [172.476, 86.325, 0], "ix": 1, "l": 2 },
        "s": {
          "a": 1,
          "k": [
            {
              "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
              "t": 0,
              "s": [100, 100, 100]
            },
            {
              "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
              "t": 7,
              "s": [105, 105, 100]
            },
            {
              "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
              "t": 49,
              "s": [105, 105, 100]
            },
            { "t": 56, "s": [100, 100, 100] }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [[0, 0], [0, 0], [10.43, -4.06], [0, 0]],
                      "o": [[0, 0], [0, -11.192], [0, 0], [0, 0]],
                      "v": [
                        [28.031, 24.874],
                        [28.031, -5.989],
                        [6.35, -20.814],
                        [-28.031, -7.432]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": {
                    "a": 0,
                    "k": [1, 0.795999983245, 0.423999980852, 1],
                    "ix": 4
                  },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [258.964, 49.376], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 18",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [[0, 0], [0, 0], [-10.43, -4.06], [0, 0]],
                      "o": [[0, 0], [0, -11.192], [0, 0], [0, 0]],
                      "v": [
                        [-28.03, 24.874],
                        [-28.03, -5.989],
                        [-6.35, -20.814],
                        [28.03, -7.432]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": {
                    "a": 0,
                    "k": [1, 0.795999983245, 0.423999980852, 1],
                    "ix": 4
                  },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [84.801, 47.126], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 19",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 2,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-10.56, -3.798],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, -11.46]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, -11.223],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [10.644, -4.248],
                        [0, 0]
                      ],
                      "v": [
                        [127.702, 84.536],
                        [-127.702, 84.536],
                        [-127.702, -60.231],
                        [-106.012, -75.481],
                        [-38.673, -51.259],
                        [32.76, -51.259],
                        [105.488, -80.288],
                        [127.702, -65.237]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [1, 0.725, 0.313999998803, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [172.476, 84.786], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 20",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 3,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [172.476, 86.325], "ix": 2 },
              "a": { "a": 0, "k": [172.476, 86.325], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 26",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 150,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 17,
      "ty": 4,
      "nm": "chin",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [392.685, 272.238, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [173.588, 151.4, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 49,
                    "s": [
                      {
                        "i": [[0, 0], [0, 0], [0, 0]],
                        "o": [[0, 0], [0, 0], [0, 0]],
                        "v": [
                          [19.44, 28.03],
                          [-5.878, -28.03],
                          [-19.44, 10.85]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 53,
                    "s": [
                      {
                        "i": [[0, 0], [0, 0], [0, 0]],
                        "o": [[0, 0], [0, 0], [0, 0]],
                        "v": [
                          [19.44, 28.03],
                          [-5.878, -23.046],
                          [-19.44, 12.378]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 77,
                    "s": [
                      {
                        "i": [[0, 0], [0, 0], [0, 0]],
                        "o": [[0, 0], [0, 0], [0, 0]],
                        "v": [
                          [19.44, 28.03],
                          [-5.878, -23.046],
                          [-19.44, 12.378]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "t": 81,
                    "s": [
                      {
                        "i": [[0, 0], [0, 0], [0, 0]],
                        "o": [[0, 0], [0, 0], [0, 0]],
                        "v": [
                          [19.44, 28.03],
                          [-5.878, -28.03],
                          [-19.44, 10.85]
                        ],
                        "c": true
                      }
                    ]
                  }
                ],
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [1, 0.725, 0.313999998803, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [305.9, 120.209], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 21",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 49,
                    "s": [
                      {
                        "i": [[0, 0], [0, 0], [0, 0]],
                        "o": [[0, 0], [0, 0], [0, 0]],
                        "v": [[-19.44, 28.03], [5.878, -28.03], [19.44, 10.85]],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 53,
                    "s": [
                      {
                        "i": [[0, 0], [0, 0], [0, 0]],
                        "o": [[0, 0], [0, 0], [0, 0]],
                        "v": [
                          [-19.44, 28.03],
                          [5.878, -22.046],
                          [19.44, 12.684]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 77,
                    "s": [
                      {
                        "i": [[0, 0], [0, 0], [0, 0]],
                        "o": [[0, 0], [0, 0], [0, 0]],
                        "v": [
                          [-19.44, 28.03],
                          [5.878, -22.046],
                          [19.44, 12.684]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "t": 81,
                    "s": [
                      {
                        "i": [[0, 0], [0, 0], [0, 0]],
                        "o": [[0, 0], [0, 0], [0, 0]],
                        "v": [[-19.44, 28.03], [5.878, -28.03], [19.44, 10.85]],
                        "c": true
                      }
                    ]
                  }
                ],
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [1, 0.725, 0.313999998803, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [40.099, 120.209], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 22",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 2,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 49,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [2.448, -1.416],
                          [1.881, -1.031],
                          [19.927, -5.745],
                          [15.173, -1.739],
                          [10.54, 0],
                          [43.859, 27.574],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [-2.408, 1.497],
                          [-1.841, 1.092],
                          [-18.228, 10.115],
                          [-14.626, 4.208],
                          [-10.398, 1.194],
                          [-51.81, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [154.012, -23.467],
                          [146.446, -18.713],
                          [139.183, -14.323],
                          [133.6, -11.127],
                          [76.186, 12.725],
                          [31.417, 21.666],
                          [0.001, 23.467],
                          [-146.425, -18.713],
                          [-154.012, -23.467]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 53,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [2.448, -1.416],
                          [1.881, -1.031],
                          [19.927, -5.745],
                          [15.173, -1.739],
                          [10.54, 0],
                          [43.859, 27.574],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [-2.408, 1.497],
                          [-1.841, 1.092],
                          [-18.228, 10.115],
                          [-14.626, 4.208],
                          [-10.398, 1.194],
                          [-51.81, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [159.315, -39.23],
                          [146.446, -18.713],
                          [139.183, -14.323],
                          [133.6, -11.127],
                          [76.186, 12.725],
                          [31.418, 21.666],
                          [0.001, 23.467],
                          [-146.425, -18.713],
                          [-164.185, -39.23]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.667, "y": 1 },
                    "o": { "x": 0.333, "y": 0 },
                    "t": 77,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [2.448, -1.416],
                          [1.881, -1.031],
                          [19.927, -5.745],
                          [15.173, -1.739],
                          [10.54, 0],
                          [43.859, 27.574],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [-2.408, 1.497],
                          [-1.841, 1.092],
                          [-18.228, 10.115],
                          [-14.626, 4.208],
                          [-10.398, 1.194],
                          [-51.81, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [159.315, -39.23],
                          [146.446, -18.713],
                          [139.183, -14.323],
                          [133.6, -11.127],
                          [76.186, 12.725],
                          [31.418, 21.666],
                          [0.001, 23.467],
                          [-146.425, -18.713],
                          [-164.185, -39.23]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "t": 81,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [2.448, -1.416],
                          [1.881, -1.031],
                          [19.927, -5.745],
                          [15.173, -1.739],
                          [10.54, 0],
                          [43.859, 27.574],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [-2.408, 1.497],
                          [-1.841, 1.092],
                          [-18.228, 10.115],
                          [-14.626, 4.208],
                          [-10.398, 1.194],
                          [-51.81, 0],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [154.012, -23.467],
                          [146.446, -18.713],
                          [139.183, -14.323],
                          [133.6, -11.127],
                          [76.186, 12.725],
                          [31.417, 21.666],
                          [0.001, 23.467],
                          [-146.425, -18.713],
                          [-154.012, -23.467]
                        ],
                        "c": true
                      }
                    ]
                  }
                ],
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [1, 0.725, 0.313999998803, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [173.588, 187.155], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 23",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 3,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 150,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 18,
      "ty": 4,
      "nm": "Group 8",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [306.183, 508.615, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [83.96, 86.468, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [[0, -3.654], [3.655, 0], [0, 3.654], [-3.654, 0]],
                      "o": [[0, 3.654], [-3.654, 0], [0, -3.654], [3.655, 0]],
                      "v": [
                        [6.617, 0],
                        [-0.001, 6.617],
                        [-6.617, 0],
                        [-0.001, -6.617]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": {
                    "a": 0,
                    "k": [0.136999990426, 0.226999993418, 0.33300000359, 1],
                    "ix": 4
                  },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [88.762, 92.117], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [[0, -3.654], [3.655, 0], [0, 3.654], [-3.654, 0]],
                      "o": [[0, 3.654], [-3.654, 0], [0, -3.654], [3.655, 0]],
                      "v": [
                        [6.617, 0],
                        [-0.001, 6.617],
                        [-6.617, 0],
                        [-0.001, -6.617]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": {
                    "a": 0,
                    "k": [0.136999990426, 0.226999993418, 0.33300000359, 1],
                    "ix": 4
                  },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [75.528, 92.117], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 2",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 2,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [[0, -4.32], [4.32, 0], [0, 4.32], [-4.319, 0]],
                      "o": [[0, 4.32], [-4.319, 0], [0, -4.32], [4.32, 0]],
                      "v": [
                        [7.822, 0],
                        [-0.001, 7.822],
                        [-7.822, 0],
                        [-0.001, -7.822]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": {
                    "a": 0,
                    "k": [0.136999990426, 0.226999993418, 0.33300000359, 1],
                    "ix": 4
                  },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [101.965, 91.281], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 3",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 3,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [[0, -2.976], [2.976, 0], [0, 2.976], [-2.976, 0]],
                      "o": [[0, 2.976], [-2.976, 0], [0, -2.976], [2.976, 0]],
                      "v": [[5.389, 0], [0, 5.389], [-5.389, 0], [0, -5.389]],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": {
                    "a": 0,
                    "k": [0.136999990426, 0.226999993418, 0.33300000359, 1],
                    "ix": 4
                  },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [63.523, 92.042], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 4",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 4,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [[14.263, 0], [0, -10.098], [0, 0]],
                      "o": [[-14.263, 0], [0, 0], [0, -10.098]],
                      "v": [
                        [11.667, -9.142],
                        [-25.929, 9.142],
                        [25.723, 9.142]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": {
                    "a": 0,
                    "k": [0.136999990426, 0.226999993418, 0.33300000359, 1],
                    "ix": 4
                  },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [84.064, 82.975], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 5",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 5,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [83.96, 86.468], "ix": 2 },
              "a": { "a": 0, "k": [83.96, 86.468], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 8",
          "np": 5,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 150,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 19,
      "ty": 4,
      "nm": "Group 9",
      "parent": 18,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [85.784, 87.112, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [85.784, 87.112, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-21.551, -11.503],
                        [-9.959, -18.727],
                        [16.755, 0],
                        [11.596, 6.189],
                        [-11.502, 21.552]
                      ],
                      "o": [
                        [11.596, 6.189],
                        [7.868, 14.793],
                        [-23.07, 0],
                        [-21.551, -11.503],
                        [11.503, -21.551]
                      ],
                      "v": [
                        [14.236, -36.365],
                        [49.249, 10.25],
                        [30.796, 44.824],
                        [-27.419, 41.679],
                        [-45.615, -18.171]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [1, 0.725, 0.313999998803, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [57.366, 48.118], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 6",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-21.551, -11.503],
                        [-9.96, -18.727],
                        [16.755, 0],
                        [11.596, 6.189],
                        [-11.502, 21.552]
                      ],
                      "o": [
                        [11.596, 6.189],
                        [7.867, 14.793],
                        [-23.07, 0],
                        [-21.551, -11.503],
                        [11.503, -21.551]
                      ],
                      "v": [
                        [11.611, -36.365],
                        [51.874, 20.338],
                        [28.171, 44.824],
                        [-30.044, 41.679],
                        [-48.239, -18.171]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": {
                    "a": 0,
                    "k": [1, 0.681999954523, 0.263000009574, 1],
                    "ix": 4
                  },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [68.991, 48.118], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 7",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 2,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [64.784, 50.112], "ix": 2 },
              "a": { "a": 0, "k": [64.784, 50.112], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 9",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 150,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 20,
      "ty": 4,
      "nm": "Group 8",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [479.904, 508.615, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [45.022, 86.468, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [[0, -3.654], [-3.655, 0], [0, 3.654], [3.654, 0]],
                      "o": [[0, 3.654], [3.654, 0], [0, -3.654], [-3.655, 0]],
                      "v": [[-6.616, 0], [0, 6.617], [6.616, 0], [0, -6.617]],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": {
                    "a": 0,
                    "k": [0.136999990426, 0.226999993418, 0.33300000359, 1],
                    "ix": 4
                  },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [40.221, 92.117], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [[0, -3.654], [-3.655, 0], [0, 3.654], [3.654, 0]],
                      "o": [[0, 3.654], [3.654, 0], [0, -3.654], [-3.655, 0]],
                      "v": [[-6.616, 0], [0, 6.617], [6.616, 0], [0, -6.617]],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": {
                    "a": 0,
                    "k": [0.136999990426, 0.226999993418, 0.33300000359, 1],
                    "ix": 4
                  },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [53.454, 92.117], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 2",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 2,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [[0, -4.32], [-4.32, 0], [0, 4.32], [4.319, 0]],
                      "o": [[0, 4.32], [4.319, 0], [0, -4.32], [-4.32, 0]],
                      "v": [
                        [-7.821, 0],
                        [0.001, 7.822],
                        [7.821, 0],
                        [0.001, -7.822]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": {
                    "a": 0,
                    "k": [0.136999990426, 0.226999993418, 0.33300000359, 1],
                    "ix": 4
                  },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [27.018, 91.281], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 3",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 3,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [[0, -2.976], [-2.976, 0], [0, 2.976], [2.976, 0]],
                      "o": [[0, 2.976], [2.976, 0], [0, -2.976], [-2.976, 0]],
                      "v": [[-5.389, 0], [0, 5.389], [5.389, 0], [0, -5.389]],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": {
                    "a": 0,
                    "k": [0.136999990426, 0.226999993418, 0.33300000359, 1],
                    "ix": 4
                  },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [65.46, 92.042], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 4",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 4,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [[-14.263, 0], [0, -10.098], [0, 0]],
                      "o": [[14.263, 0], [0, 0], [0, -10.098]],
                      "v": [
                        [-11.666, -9.142],
                        [25.929, 9.142],
                        [-25.722, 9.142]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": {
                    "a": 0,
                    "k": [0.136999990426, 0.226999993418, 0.33300000359, 1],
                    "ix": 4
                  },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [44.919, 82.975], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 5",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 5,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [45.022, 86.468], "ix": 2 },
              "a": { "a": 0, "k": [45.022, 86.468], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 8",
          "np": 5,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 150,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 21,
      "ty": 4,
      "nm": "Group 9",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [473.079, 506.259, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [38.198, 84.112, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [21.551, -11.503],
                        [9.959, -18.727],
                        [-16.755, 0],
                        [-11.596, 6.189],
                        [11.502, 21.552]
                      ],
                      "o": [
                        [-11.596, 6.189],
                        [-7.868, 14.793],
                        [23.07, 0],
                        [21.551, -11.503],
                        [-11.503, -21.551]
                      ],
                      "v": [
                        [-14.235, -36.365],
                        [-49.248, 10.25],
                        [-30.796, 44.824],
                        [27.42, 41.679],
                        [45.614, -18.171]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [1, 0.725, 0.313999998803, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [71.616, 48.118], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 6",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [21.551, -11.503],
                        [9.96, -18.727],
                        [-16.755, 0],
                        [-11.596, 6.189],
                        [11.502, 21.552]
                      ],
                      "o": [
                        [-11.596, 6.189],
                        [-7.867, 14.793],
                        [23.07, 0],
                        [21.551, -11.503],
                        [-11.503, -21.551]
                      ],
                      "v": [
                        [-11.611, -36.365],
                        [-51.874, 20.338],
                        [-28.171, 44.824],
                        [30.044, 41.679],
                        [48.239, -18.171]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": {
                    "a": 0,
                    "k": [1, 0.681999954523, 0.263000009574, 1],
                    "ix": 4
                  },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [59.991, 48.118], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 7",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 2,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [64.198, 50.112], "ix": 2 },
              "a": { "a": 0, "k": [64.198, 50.112], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 9",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 150,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 22,
      "ty": 4,
      "nm": "body Outlines",
      "parent": 20,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [-44.893, 93.592, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [124.644, 197.338, 0], "ix": 1, "l": 2 },
        "s": {
          "a": 1,
          "k": [
            {
              "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
              "t": 42,
              "s": [100, 100, 100]
            },
            {
              "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
              "t": 50,
              "s": [105, 95, 100]
            },
            {
              "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
              "t": 59,
              "s": [95, 105, 100]
            },
            { "t": 69, "s": [100, 100, 100] }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [32.674, 0],
                    [0, 0],
                    [0, 32.674],
                    [0, 0],
                    [-32.674, 0],
                    [0, 0],
                    [0, -32.673],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [-32.674, 0],
                    [0, 0],
                    [0, -32.673],
                    [0, 0],
                    [32.674, 0],
                    [0, 0],
                    [0, 32.674]
                  ],
                  "v": [
                    [3.303, 59.161],
                    [-3.303, 59.161],
                    [-62.464, 0.001],
                    [-62.464, -0.001],
                    [-3.303, -59.161],
                    [3.303, -59.161],
                    [62.464, -0.001],
                    [62.464, 0.001]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [1, 0.795999983245, 0.423999980852, 1],
                "ix": 4
              },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [126.084, 123.758], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [[58.807, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                  "o": [[-58.807, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
                  "v": [
                    [0, 12.105],
                    [-80.348, -2.209],
                    [-78.157, -12.105],
                    [77.757, -12.105],
                    [80.348, -2.209]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [1, 0.681999954523, 0.263000009574, 1],
                "ix": 4
              },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [123.48, 12.355], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 2",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 2,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [21.282, -0.222],
                    [0, 0],
                    [-3.601, 20.656],
                    [-3.58, 13.919],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-1.882, -8.517]
                  ],
                  "o": [
                    [0, 0],
                    [-20.958, 0.202],
                    [1.74, -9.953],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [3.236, 12.583],
                    [4.592, 20.776]
                  ],
                  "v": [
                    [86.393, 97.165],
                    [-86.413, 98.885],
                    [-119.793, 59.597],
                    [-110.73, 25.187],
                    [-78.321, -99.088],
                    [77.593, -99.088],
                    [110.346, 26.036],
                    [118.802, 56.442]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [1, 0.725, 0.313999998803, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [123.644, 99.338], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 3",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 3,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 150,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 23,
      "ty": 4,
      "nm": "tail Outlines 2",
      "parent": 22,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 12, "ix": 10 },
        "p": { "a": 0, "k": [208.732, 147.156, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [165.362, 167.747, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [-100, 100, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.056 },
                    "t": -3,
                    "s": [
                      {
                        "i": [[0, 0], [6.077, 1.754], [0.1, -0.201], [0, 0]],
                        "o": [[0, 0], [-0.305, 0.389], [3.582, 1.574], [0, 0]],
                        "v": [
                          [56.593, -6.791],
                          [-0.47, -56.38],
                          [-59.104, 12.028],
                          [-6.791, 56.593]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.944 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 18,
                    "s": [
                      {
                        "i": [[0, 0], [0, 0], [0, 0], [0, 0]],
                        "o": [[0, 0], [0, 0], [0, 0], [0, 0]],
                        "v": [
                          [56.593, -6.791],
                          [6.791, -56.593],
                          [-56.594, 6.791],
                          [-6.791, 56.593]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.056 },
                    "t": 42,
                    "s": [
                      {
                        "i": [[0, 0], [2.553, 4.91], [0.188, -0.057], [0, 0]],
                        "o": [[0, 0], [-0.431, 0.041], [1.162, 3.22], [0, 0]],
                        "v": [
                          [59.606, -4.872],
                          [14.556, -52.894],
                          [-55.414, 0.857],
                          [-6.826, 56.677]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 1 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 63,
                    "s": [
                      {
                        "i": [[0, 0], [0, 0], [0, 0], [0, 0]],
                        "o": [[0, 0], [0, 0], [0, 0], [0, 0]],
                        "v": [
                          [56.593, -6.791],
                          [6.791, -56.593],
                          [-56.594, 6.791],
                          [-6.791, 56.593]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.056 },
                    "t": 87,
                    "s": [
                      {
                        "i": [[0, 0], [6.077, 1.754], [0.1, -0.201], [0, 0]],
                        "o": [[0, 0], [-0.305, 0.389], [3.582, 1.574], [0, 0]],
                        "v": [
                          [56.593, -6.791],
                          [-0.47, -56.38],
                          [-59.104, 12.028],
                          [-6.791, 56.593]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.944 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 108,
                    "s": [
                      {
                        "i": [[0, 0], [0, 0], [0, 0], [0, 0]],
                        "o": [[0, 0], [0, 0], [0, 0], [0, 0]],
                        "v": [
                          [56.593, -6.791],
                          [6.791, -56.593],
                          [-56.594, 6.791],
                          [-6.791, 56.593]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.056 },
                    "t": 132,
                    "s": [
                      {
                        "i": [[0, 0], [2.553, 4.91], [0.188, -0.057], [0, 0]],
                        "o": [[0, 0], [-0.431, 0.041], [1.162, 3.22], [0, 0]],
                        "v": [
                          [59.606, -4.872],
                          [14.556, -52.894],
                          [-55.414, 0.857],
                          [-6.826, 56.677]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 1 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 153,
                    "s": [
                      {
                        "i": [[0, 0], [0, 0], [0, 0], [0, 0]],
                        "o": [[0, 0], [0, 0], [0, 0], [0, 0]],
                        "v": [
                          [56.593, -6.791],
                          [6.791, -56.593],
                          [-56.594, 6.791],
                          [-6.791, 56.593]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "t": 177,
                    "s": [
                      {
                        "i": [[0, 0], [6.077, 1.754], [0.1, -0.201], [0, 0]],
                        "o": [[0, 0], [-0.305, 0.389], [3.582, 1.574], [0, 0]],
                        "v": [
                          [56.593, -6.791],
                          [-0.47, -56.38],
                          [-59.104, 12.028],
                          [-6.791, 56.593]
                        ],
                        "c": true
                      }
                    ]
                  }
                ],
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.136999990426, 0.226999993418, 0.33300000359, 1],
                "ix": 4
              },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [135.078, 135.078], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 2",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.056 },
                    "t": -3,
                    "s": [
                      {
                        "i": [
                          [6.994, 3.706],
                          [7.296, -0.07],
                          [-0.025, -0.081],
                          [-1.875, -0.909]
                        ],
                        "o": [
                          [-6.994, -3.706],
                          [0.095, -0.002],
                          [2.057, -0.183],
                          [1.875, 0.909]
                        ],
                        "v": [
                          [49.148, -6.762],
                          [-12.854, -47.701],
                          [-59.461, 23.302],
                          [-9.485, 61.646]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.944 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 18,
                    "s": [
                      {
                        "i": [[0, 0], [0, 0], [0, 0], [0, 0]],
                        "o": [[0, 0], [0, 0], [0, 0], [0, 0]],
                        "v": [
                          [56.41, -6.975],
                          [6.974, -56.41],
                          [-56.41, 6.975],
                          [-6.975, 56.41]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.056 },
                    "t": 42,
                    "s": [
                      {
                        "i": [
                          [2.633, 6.406],
                          [-0.125, 8.327],
                          [0.074, 0.004],
                          [-4.185, -10.234]
                        ],
                        "o": [
                          [-2.261, -5.502],
                          [-0.028, 0.079],
                          [-0.874, 4.791],
                          [0.69, 1.687]
                        ],
                        "v": [
                          [64.174, -3.275],
                          [24.234, -54.67],
                          [-46.312, -11.97],
                          [-5.795, 50.475]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 1 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 63,
                    "s": [
                      {
                        "i": [[0, 0], [0, 0], [0, 0], [0, 0]],
                        "o": [[0, 0], [0, 0], [0, 0], [0, 0]],
                        "v": [
                          [56.41, -6.975],
                          [6.974, -56.41],
                          [-56.41, 6.975],
                          [-6.975, 56.41]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.056 },
                    "t": 87,
                    "s": [
                      {
                        "i": [
                          [6.994, 3.706],
                          [7.296, -0.07],
                          [-0.025, -0.081],
                          [-1.875, -0.909]
                        ],
                        "o": [
                          [-6.994, -3.706],
                          [0.095, -0.002],
                          [2.057, -0.183],
                          [1.875, 0.909]
                        ],
                        "v": [
                          [49.148, -6.762],
                          [-12.854, -47.701],
                          [-59.461, 23.302],
                          [-9.485, 61.646]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.944 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 108,
                    "s": [
                      {
                        "i": [[0, 0], [0, 0], [0, 0], [0, 0]],
                        "o": [[0, 0], [0, 0], [0, 0], [0, 0]],
                        "v": [
                          [56.41, -6.975],
                          [6.974, -56.41],
                          [-56.41, 6.975],
                          [-6.975, 56.41]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.056 },
                    "t": 132,
                    "s": [
                      {
                        "i": [
                          [2.633, 6.406],
                          [-0.125, 8.327],
                          [0.074, 0.004],
                          [-4.185, -10.234]
                        ],
                        "o": [
                          [-2.261, -5.502],
                          [-0.028, 0.079],
                          [-0.874, 4.791],
                          [0.69, 1.687]
                        ],
                        "v": [
                          [64.174, -3.275],
                          [24.234, -54.67],
                          [-46.312, -11.97],
                          [-5.795, 50.475]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 1 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 153,
                    "s": [
                      {
                        "i": [[0, 0], [0, 0], [0, 0], [0, 0]],
                        "o": [[0, 0], [0, 0], [0, 0], [0, 0]],
                        "v": [
                          [56.41, -6.975],
                          [6.974, -56.41],
                          [-56.41, 6.975],
                          [-6.975, 56.41]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "t": 177,
                    "s": [
                      {
                        "i": [
                          [6.994, 3.706],
                          [7.296, -0.07],
                          [-0.025, -0.081],
                          [-1.875, -0.909]
                        ],
                        "o": [
                          [-6.994, -3.706],
                          [0.095, -0.002],
                          [2.057, -0.183],
                          [1.875, 0.909]
                        ],
                        "v": [
                          [49.148, -6.762],
                          [-12.854, -47.701],
                          [-59.461, 23.302],
                          [-9.485, 61.646]
                        ],
                        "c": true
                      }
                    ]
                  }
                ],
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [1, 0.725, 0.313999998803, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [85.46, 85.46], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 3",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 2,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.056 },
                    "t": -3,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [2.061, -0.294],
                          [11.314, -17.37],
                          [0, 0],
                          [-17.369, -11.315],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [-16.211, -11.229],
                          [0, 0],
                          [-11.314, 17.37],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [26.376, -8.538],
                          [11.37, -18.01],
                          [-40.056, -7.013],
                          [-45.041, 0.639],
                          [-34.078, 52.576],
                          [-20.23, 62.465]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.944 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 18,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [15.604, -15.605],
                          [0, 0],
                          [-15.604, -15.605],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [-15.605, -15.605],
                          [0, 0],
                          [-15.604, 15.605],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [46.185, -17.2],
                          [32.805, -30.579],
                          [-23.706, -30.579],
                          [-30.581, -23.705],
                          [-30.581, 32.805],
                          [-17.2, 46.184]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.056 },
                    "t": 42,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [-0.389, 1.78],
                          [16.825, -10.06],
                          [0, 0],
                          [-10.059, -16.826],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [-10.484, -15.902],
                          [0, 0],
                          [-16.825, 10.06],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [63.375, -15.446],
                          [53.7, -27.767],
                          [3.701, -39.37],
                          [-3.712, -34.939],
                          [-16.173, 13.741],
                          [-7.171, 27.253]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 1 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 63,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [15.604, -15.605],
                          [0, 0],
                          [-15.604, -15.605],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [-15.605, -15.605],
                          [0, 0],
                          [-15.604, 15.605],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [46.185, -17.2],
                          [32.805, -30.579],
                          [-23.706, -30.579],
                          [-30.581, -23.705],
                          [-30.581, 32.805],
                          [-17.2, 46.184]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.056 },
                    "t": 87,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [2.061, -0.294],
                          [11.314, -17.37],
                          [0, 0],
                          [-17.369, -11.315],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [-16.211, -11.229],
                          [0, 0],
                          [-11.314, 17.37],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [26.376, -8.538],
                          [11.37, -18.01],
                          [-40.056, -7.013],
                          [-45.041, 0.639],
                          [-34.078, 52.576],
                          [-20.23, 62.465]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.944 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 108,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [15.604, -15.605],
                          [0, 0],
                          [-15.604, -15.605],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [-15.605, -15.605],
                          [0, 0],
                          [-15.604, 15.605],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [46.185, -17.2],
                          [32.805, -30.579],
                          [-23.706, -30.579],
                          [-30.581, -23.705],
                          [-30.581, 32.805],
                          [-17.2, 46.184]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 0.833 },
                    "o": { "x": 0.167, "y": 0.056 },
                    "t": 132,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [-0.389, 1.78],
                          [16.825, -10.06],
                          [0, 0],
                          [-10.059, -16.826],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [-10.484, -15.902],
                          [0, 0],
                          [-16.825, 10.06],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [63.375, -15.446],
                          [53.7, -27.767],
                          [3.701, -39.37],
                          [-3.712, -34.939],
                          [-16.173, 13.741],
                          [-7.171, 27.253]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "i": { "x": 0.833, "y": 1 },
                    "o": { "x": 0.167, "y": 0.167 },
                    "t": 153,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [0, 0],
                          [15.604, -15.605],
                          [0, 0],
                          [-15.604, -15.605],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [-15.605, -15.605],
                          [0, 0],
                          [-15.604, 15.605],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [46.185, -17.2],
                          [32.805, -30.579],
                          [-23.706, -30.579],
                          [-30.581, -23.705],
                          [-30.581, 32.805],
                          [-17.2, 46.184]
                        ],
                        "c": true
                      }
                    ]
                  },
                  {
                    "t": 177,
                    "s": [
                      {
                        "i": [
                          [0, 0],
                          [2.061, -0.294],
                          [11.314, -17.37],
                          [0, 0],
                          [-17.369, -11.315],
                          [0, 0]
                        ],
                        "o": [
                          [0, 0],
                          [-16.211, -11.229],
                          [0, 0],
                          [-11.314, 17.37],
                          [0, 0],
                          [0, 0]
                        ],
                        "v": [
                          [26.376, -8.538],
                          [11.37, -18.01],
                          [-40.056, -7.013],
                          [-45.041, 0.639],
                          [-34.078, 52.576],
                          [-20.23, 62.465]
                        ],
                        "c": true
                      }
                    ]
                  }
                ],
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [0.136999990426, 0.226999993418, 0.33300000359, 1],
                "ix": 4
              },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [46.435, 46.435], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 4",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 3,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 150,
      "st": -3,
      "bm": 0
    }
  ],
  "markers": [{ "tm": 0, "cm": "1", "dr": 0 }, { "tm": 90, "cm": "2", "dr": 0 }]
}
